(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1424],{

/***/ 92763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ infrastructure; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/scroll/use-viewport-scroll.mjs
var use_viewport_scroll = __webpack_require__(85791);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/use-transform.mjs + 1 modules
var use_transform = __webpack_require__(29682);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/use-spring.mjs
var use_spring = __webpack_require__(33066);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(48714);
// EXTERNAL MODULE: ../../libs/matcha/components/Media/index.ts + 2 modules
var Media = __webpack_require__(75091);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/Hero/assets/Hero@2x.png
var Hero_2x = __webpack_require__(32924);
var Hero_2x_default = /*#__PURE__*/__webpack_require__.n(Hero_2x);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/Hero/assets/Hero.webp
var Hero = __webpack_require__(77517);
var Hero_default = /*#__PURE__*/__webpack_require__.n(Hero);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/Hero/assets/Hero@2x.webp
var assets_Hero_2x = __webpack_require__(36863);
var assets_Hero_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/Hero/HeroImage.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var SIZES = "(max-width: 1000px) 1352px, 2702px";

var calculateTransformPercentage = function calculateTransformPercentage(scrollY) {
  var newValue = scrollY * 14000;
  return newValue > 75 ? 75 : newValue;
};

var HeroImage = function HeroImage() {
  var _useViewportScroll = (0,use_viewport_scroll/* useViewportScroll */.M)(),
      scrollYProgress = _useViewportScroll.scrollYProgress;

  var multipliedScrollYProgress = (0,use_transform/* useTransform */.H)(scrollYProgress, function (latest) {
    return 10 - calculateTransformPercentage(latest);
  });
  var springScrollYProgress = (0,use_spring/* useSpring */.q)(multipliedScrollYProgress, {
    stiffness: 70,
    damping: 30,
    restDelta: 0.001
  });
  var percentageScrollYProgress = (0,use_transform/* useTransform */.H)(springScrollYProgress, function (latest) {
    return "".concat(latest, "%");
  });

  var Picture = function Picture() {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledPicture, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        width: "1352",
        height: "497",
        type: "image/webp",
        srcSet: "".concat((Hero_default()), " 1352w, ").concat((assets_Hero_2x_default()), " 2702w"),
        sizes: SIZES
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Image */.Ee, {
        width: "1352",
        height: "497",
        src: (Hero_2x_default()),
        sizes: SIZES,
        alt: "",
        loading: "lazy"
      })]
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      greaterThanOrEqual: "md",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LargeScreenWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Picture, {})
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      lessThan: "md",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImageContainer, {
        style: {
          translateX: percentageScrollYProgress
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Picture, {})
      })
    })]
  });
};

var LargeScreenWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e18ztvce2"
} : 0)( true ? {
  name: "1gi3dzp",
  styles: "position:relative;height:0;width:100%;padding-top:calc(497 / 1352 * 100%)"
} : 0);

var StyledPicture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "e18ztvce1"
} : 0)( true ? {
  name: "1557nw",
  styles: "position:absolute;top:0;left:0;max-width:100%;height:auto"
} : 0);

var StyledImageContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.div,  true ? {
  target: "e18ztvce0"
} : 0)( true ? {
  name: "ji8b2p",
  styles: "width:225%;max-width:225%;position:relative;transform:translateX(10%);padding-top:calc(497 / 1352 * 250%);height:0"
} : 0);

/* harmony default export */ var Hero_HeroImage = (HeroImage);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/Hero/Hero.tsx


function Hero_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var copy = {
  overline: "Infrastructure",
  heading: "The Segment Infrastructure",
  description: "Under the hood of the system that processes 400,000 events every second."
};

var Hero_Hero = function Hero() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHero, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
          tag: "h5",
          variant: "h5",
          children: copy.overline
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h1",
          tag: "h1",
          children: copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pExtraLarge",
          tag: "p",
          children: copy.description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_HeroImage, {})
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e1n70r3h1"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.green[10];
}, ";overflow-x:hidden;" + ( true ? "" : 0));

var StyledHero = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "e1n70r3h0"
} : 0)( true ? {
  name: "1w52kv1",
  styles: "max-width:1440px"
} : 0);

/* harmony default export */ var components_Hero_Hero = (Hero_Hero);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Subnav/index.ts + 20 modules
var Subnav = __webpack_require__(49833);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/Subnavigation/data.ts
var data = [{
  label: "Collection",
  items: [{
    label: "Libraries",
    id: "libraries"
  }, {
    label: "Cloud Sources",
    id: "cloud-sources"
  }, {
    label: "Source Functions",
    id: "source-functions"
  }, {
    label: "API",
    id: "api"
  }]
}, {
  label: "Processing",
  items: [{
    label: "Validation and Transformation",
    id: "validation-and-transformation"
  }, {
    label: "Deduplication",
    id: "deduplication"
  }, {
    label: "GDPR Suppression and Deletion",
    id: "gdpr-suppression-and-deletion"
  }]
}, {
  label: "Aggregation",
  items: [{
    label: "Identity Resolution",
    id: "identity-resolution"
  }, {
    label: "Profile API",
    id: "profile-api"
  }, {
    label: "Reverse ETL",
    id: "reverse-etl"
  }, {
    label: "Audience Creation",
    id: "audience-creation"
  }]
}, {
  label: "Delivery",
  items: [{
    label: "Centrifuge",
    id: "centrifuge"
  }, {
    label: "Destinations",
    id: "destinations"
  }, {
    label: "Warehouses / ETL",
    id: "warehouses-etl"
  }]
}];
/* harmony default export */ var Subnavigation_data = (data);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/Subnavigation/SubnavigationAnchor.tsx




var SubnavigationAnchor = function SubnavigationAnchor(_ref) {
  var label = _ref.label,
      id = _ref.id;
  var scroll = (0,useScrollToAnchor/* default */.Z)(id, -100);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subnav/* Item */.c, {
    label: label,
    href: "#".concat(id),
    "aria-label": label,
    onClick: function onClick(e) {
      e.preventDefault();
      scroll();
    }
  });
};

/* harmony default export */ var Subnavigation_SubnavigationAnchor = (SubnavigationAnchor);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/Subnavigation/Subnavigation.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Subnavigation_copy = {
  title: "Infrastructure"
};

var Subnavigation = function Subnavigation() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subnav/* default */.Z, {
    "aria-label": Subnavigation_copy.title,
    label: Subnavigation_copy.title,
    children: Subnavigation_data.map(function (subnavItem) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subnav/* Item */.c, {
        "aria-label": subnavItem.label,
        label: subnavItem.label,
        children: subnavItem.items && subnavItem.items.map(function (subnavDropdownItem) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subnavigation_SubnavigationAnchor, _objectSpread({}, subnavDropdownItem), subnavDropdownItem.label);
        })
      }, subnavItem.label);
    })
  });
};

/* harmony default export */ var Subnavigation_Subnavigation = (Subnavigation);
// EXTERNAL MODULE: ../../node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(24330);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/Collection/assets/Collection@2x.png
var Collection_2x = __webpack_require__(91460);
var Collection_2x_default = /*#__PURE__*/__webpack_require__.n(Collection_2x);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/Collection/assets/Collection.webp
var Collection = __webpack_require__(89456);
var Collection_default = /*#__PURE__*/__webpack_require__.n(Collection);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/Collection/assets/Collection@2x.webp
var assets_Collection_2x = __webpack_require__(85428);
var assets_Collection_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Collection_2x);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/Collection/CollectionImage.tsx







var CollectionImage = function CollectionImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((Collection_default()), ", ").concat((assets_Collection_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "640",
      height: "638",
      src: (Collection_2x_default()),
      alt: "Collection",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var Collection_CollectionImage = (CollectionImage);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/Collection/Collection.tsx


function Collection_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var Collection_data = {
  heading: "Collection",
  section1: "Customer data lives everywhere: your website, your mobile apps, and internal tools.",
  section2: "That\u2019s why collecting and processing all of it is a tricky problem. Segment has built libraries, automatic sources, and functions to collect data from anywhere\u2014hundreds of thousands of times per second.",
  section3: "We\u2019ve carefully designed each of these areas to ensure they\u2019re:",
  section4: "<ul><li>Performant (batching, async, real-time, off-page)</li>\n  <li>Reliable (cross-platform, handle rate-limits, retries)</li>\n  <li>Easy (setup with a few clicks, elegant, modern API)</li></ul>",
  section5: "Here\u2019s how we do it."
};

var Collection_Collection = function Collection() {
  var heading = Collection_data.heading,
      section1 = Collection_data.section1,
      section2 = Collection_data.section2,
      section3 = Collection_data.section3,
      section4 = Collection_data.section4,
      section5 = Collection_data.section5;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Collection_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      copyVariant: "wide",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h2",
            children: heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* Description */.dk, {
            tag: "div",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyTextDescriptionSection, {
              children: section1
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyTextDescriptionSection, {
              children: section2
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyTextDescriptionSection, {
              children: section3
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyTextDescriptionSection, {
              dangerouslySetInnerHTML: {
                __html: sanitize_html_default()(section4, {
                  allowedTags: ["ul", "li", "br"]
                })
              }
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyTextDescriptionSection, {
              children: section5
            })]
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Collection_CollectionImage, {})
      })]
    })
  });
};

var CopyTextDescriptionSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ec9h0o51"
} : 0)( true ? {
  name: "1s22u92",
  styles: "margin-bottom:32px"
} : 0);

var Collection_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "ec9h0o50"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);

/* harmony default export */ var components_Collection_Collection = (Collection_Collection);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ./src/views/Infrastructure/accordionData.ts


var _accordionData;

var SectionWithAccordion;

(function (SectionWithAccordion) {
  SectionWithAccordion["LIBRARIES"] = "LIBRARIES";
  SectionWithAccordion["CLOUD_SOURCES"] = "CLOUD_SOURCES";
  SectionWithAccordion["SOURCE_FUNCTIONS"] = "SOURCE_FUNCTIONS";
  SectionWithAccordion["API"] = "API";
  SectionWithAccordion["VALIDATION_AND_TRANSFORMATION"] = "VALIDATION_AND_TRANSFORMATION";
  SectionWithAccordion["DEDUPLICATION"] = "DEDUPLICATION";
  SectionWithAccordion["GDPR_SUPPRESSION"] = "GDPR_SUPPRESSION";
  SectionWithAccordion["IDENTITY_RESOLUTION"] = "IDENTITY_RESOLUTION";
  SectionWithAccordion["PROFILE_API"] = "PROFILE_API";
  SectionWithAccordion["REVERSE_ETL"] = "REVERSE_ETL";
  SectionWithAccordion["AUDIENCE_CREATION"] = "AUDIENCE_CREATION";
  SectionWithAccordion["CENTRIFUGE"] = "CENTRIFUGE";
  SectionWithAccordion["DESTINATIONS"] = "DESTINATIONS";
  SectionWithAccordion["WAREHOUSES_ETL"] = "WAREHOUSES_ETL";
})(SectionWithAccordion || (SectionWithAccordion = {}));

var accordionData = (_accordionData = {}, (0,defineProperty/* default */.Z)(_accordionData, SectionWithAccordion.LIBRARIES, [{
  title: "Meet you in your language",
  description: "No one likes having to fiddle around with REST APIs. We\u2019ve built libraries in 12 major languages to get you up and running, quickly."
}, {
  title: "Batching",
  description: "Each batch of requests is gzip compressed, decreasing the bytes on the wire by 10-20x. Thanks to this batching and compression, our SDKs reduce energy overhead by 2-3x. This means longer battery life for your users."
}, {
  title: "Edge persistence",
  description: "JavaScript, iOS, and Android all locally queue data to make sure you don\u2019t miss events. Each library uses fast, <a href=\"https://segment.com/blog/queuefile-reliable-request-batching-android/\">atomic transactions to ensure fidelity.</a>"
}, {
  title: "Automatic retries",
  description: "If there\u2019s a network failure due to a connection reset, timeout, or DNS error, our SDKs retry until the request is successful. This improves data deliverability by 0.6%, meaning that you never miss an event."
}]), (0,defineProperty/* default */.Z)(_accordionData, SectionWithAccordion.CLOUD_SOURCES, [{
  title: "Dynamically handle rate limits",
  description: "Salesforce, Stripe, and Zendesk dynamically rate limit from 60 requests per minute to 1,000 per hour. We automatically handle these limits and backoff to get fast data without triggering resets."
}, {
  title: "Incremental syncs",
  description: "You shouldn\u2019t need to pull all data, every time. If the API supports it, we\u2019ll keep historically checkpoints and incrementally sync just the delta. This speeds sync times by 60-100x."
}, {
  title: "Merging objects",
  description: "Some APIs will only give back changes in individual fields. You don\u2019t have to materialize all of these changes yourself, we\u2019ll nicely materialize these deltas into a single \u201Cmerged\u201D object."
}]), (0,defineProperty/* default */.Z)(_accordionData, SectionWithAccordion.SOURCE_FUNCTIONS, [{
  title: "Write 20 lines of javascript",
  description: "You don\u2019t have to worry about setting up a server, terminating connections, or other configuration. We handle all of the plumbing, so you write your business logic and go."
}, {
  title: "Scaling up, concurrency, and dead letter queues",
  description: "We\u2019ll automatically scale functions up and down, as well as handle their concurrency. Any data which is discarded is automatically published to a Dead Letter Queue for later processing."
}, {
  title: "Autocompletion and testing in-browser",
  description: "No need to copy and paste little bits of JSON. Sample one live request, and then let autocomplete handle all of the rest."
}]), (0,defineProperty/* default */.Z)(_accordionData, SectionWithAccordion.API, [{
  title: "Scaled up 10x for 99.9999% availability",
  description: "We have our servers intentionally scaled down at the edge. It allows us to ingest events even with news spikes or live events."
}, {
  title: "High-performance Go servers",
  description: "Our Tracking API is written as a high-performance golang service. Each instance can handle tens of thousands of requests concurrently. We\u2019re collecting more than 800,000 RPS."
}, {
  title: "Queued locally",
  description: "We queue all data at the edge locally first. In case of a network partition, we can continue processing."
}, {
  title: "Stateless at the edge",
  description: "None of our tracking servers require configuration data. Under times of more load, we can bring up new servers without degrading our QoS."
}]), (0,defineProperty/* default */.Z)(_accordionData, SectionWithAccordion.VALIDATION_AND_TRANSFORMATION, [{
  title: "Fast, nested JSON parsing",
  description: "It\u2019s not easy to parse and match thousands of requests per second flowing. We\u2019ve <a href=\"https://github.com/segmentio/encoding\">built our own custom JSON parser which does zero-memory allocations</a>, and optimized regex parsers to ensure that your data keeps moving."
}, {
  title: "Versioned transformations",
  description: "It\u2019s simple to build a basic transformation worker\u2026 but what happens when you have 20 different versions of mobile apps out in the wild, each using different tracking? Our transformations and filters are versioned from the start to let you apply your controls with fine-grained matchers."
}]), (0,defineProperty/* default */.Z)(_accordionData, SectionWithAccordion.DEDUPLICATION, [{
  title: "Exactly-once guarantees with Kafka",
  description: "We\u2019ve partitioned Kafka based upon the ID of each message. Whenever a deduplication worker starts, it first reads the Kafka output topic as the \u201Csource of truth\u201D before processing messages."
}, {
  title: "Sub-millisecond queries with RocksDB",
  description: "Each dedupe instance queries from a RocksDB instance, which is replicated via EBS. If a database ever goes missing, it can be re-built from the log. Each one stores 1TB of message IDs on disk."
}, {
  title: "Fast-paths with Bloom Filters",
  description: "Most new messages won\u2019t be duplicated at all. RocksDB uses Bloom Filters to ensure that most IDs don\u2019t have to load from disk."
}]), (0,defineProperty/* default */.Z)(_accordionData, SectionWithAccordion.GDPR_SUPPRESSION, [{
  title: "Centralized user storage in Cerebro",
  description: "An internal service called Cerebro manages all of the state machines and cleanup work around user suppression and deletion. It\u2019s backed by Kafka and MySQL, replicated 3 times to ensure data ia actually deleted."
}, {
  title: "Receipts logged in audit database",
  description: "For every deletion and suppression request logged, we store the receipt in an audit database. It helps provide peace of mind (and compliance) that your data has actually been deleted."
}, {
  title: "Reliable fanout via ctlstore",
  description: "Each userId is automatically replicated to a local sqlite instance attached to the worker. It ensures that lookups are fast and reliable. <a href=\"https://rbranson.medium.com/sharing-sqlite-databases-across-containers-is-surprisingly-brilliant-bacb8d753054\">Read more.</a>"
}]), (0,defineProperty/* default */.Z)(_accordionData, SectionWithAccordion.IDENTITY_RESOLUTION, [{
  title: "Millisecond resolution in DynamoDB",
  description: "We\u2019ve partitioned Kafka based upon the ID of each message. Whenever a deduplication worker starts, it first reads the Kafka output topic as the \u201Csource of truth\u201D before processing messages."
}, {
  title: "Configurable with your own custom algorithm",
  description: "You have your own scheme for managing customers: emails, userIds, device identifiers. customize merging by blocking individual values, limit the number of merged user profiles, or adjust the priority and precedence of individual user IDs."
}, {
  title: "Deterministic ID matching",
  description: "We\u2019ve built our algorithms to always be deterministic. Under the hood, <a href=\"https://segment.com/blog/identity-resolution\">we create a graph of identities and a separate merge table</a> so that you can always trace how an identity was merged, and then unmerge it down the road."
}]), (0,defineProperty/* default */.Z)(_accordionData, SectionWithAccordion.PROFILE_API, [{
  title: "300ms response time",
  description: "We\u2019ve invested heavily in our infrastructure to ensure that 99% of queries are completed in <300ms"
}, {
  title: "Serving millions of requests per day",
  description: "Our Profile API has scaled to meet the personalization requirements of some of the biggest brands in the world. It currently handles millions of requests per day."
}, {
  title: "Pull a full user history in JSON",
  description: "Getting the right data to personalize can be difficult. There\u2019s lots of cryptic variables for individual audiences, which aren\u2019t fully tied together. We\u2019ve made it easy by passing back the events as JSON. They\u2019re easy to reason about and fit with your overall tracking plan."
}]), (0,defineProperty/* default */.Z)(_accordionData, SectionWithAccordion.REVERSE_ETL, [{
  title: "Sync on your schedule",
  description: "Whether you\u2019re sending data to Salesforce, Braze, or any other destination - manage compute costs and ensure teams have access to timely data."
}, {
  title: "Enrich and build unified profiles",
  description: "Send data from your warehouse to the Segment destination where it can be merged into identity-resolved profiles that can be synced back to the warehouse."
}, {
  title: "Activate data everywhere",
  description: "With access to 450+ destinations, Segment customers can send data from the warehouse down to any supported destination."
}]), (0,defineProperty/* default */.Z)(_accordionData, SectionWithAccordion.AUDIENCE_CREATION, [{
  title: "Real-time computations with Flink",
  description: "We\u2019ve built a custom Flink pipeline to ensure that users get routed with affinity, and quickly. Our pipeline can re-compute membership in audiences in real-time."
}, {
  title: "Historical computations with BigQuery",
  description: "To re-build historical audiences, we leverage BigQuery. <a href=\"https://www.youtube.com/watch?v=rECHcoGIJNU\">We\u2019ve created wide tables that allow us to run these audience re-computes over terabytes of data on the fly.</a>"
}, {
  title: "AST to SQL",
  description: "We\u2019ve built an intuitive, simple UI, to create audiences. Under the hood, we parse this into an AST which allows users to dynamically update their audiences with complex aggregations."
}]), (0,defineProperty/* default */.Z)(_accordionData, SectionWithAccordion.CENTRIFUGE, [{
  title: "Fast path wins",
  description: "Events which fail once are 10x more likely to fail on a retry. Centrifuge prioritizes real-time events to ensure that failing events don\u2019t back up the queue."
}, {
  title: "Kafka as the replay log",
  description: "Kafka acts as the backbone for Centrifuge, persisting data across availability zones and ensuring that data will never be lost."
}, {
  title: "Retry dynamically with flow control",
  description: "We retry data over a four hour period with exponential backoff. Any data which is not delivered is archived on S3."
}, {
  title: "Receipts for delivery and failure",
  description: "Any time one of your events is rejected, we\u2019ll log the error and the message. No need to plumb through error logs, the full request/response payload will show up in the Segment app."
}]), (0,defineProperty/* default */.Z)(_accordionData, SectionWithAccordion.DESTINATIONS, [{
  title: "Surface human readable errors",
  description: "Not all APIs are created equal. SOAP, XML, cryptic error codes and invalid JSON messages are often par for the course."
}, {
  title: "Tested across hundreds of APIs and data formats",
  description: "Each day, our integrations pipeline processes data from 25,000+ companies sending to ".concat("450", "+ integrations. we automatically map every variation of \u201CUser Signed Up\u201D \u201CSigned Up\u201D \u201Csignup\u201D and \u201Cuser_signup\u201D so you don\u2019t have to.")
}, {
  title: "Per-event visibility",
  description: "Any time one of your events is rejected, we\u2019ll log the error and the message. No need to plumb through error logs, the full request/response payload will show up in the Segment app."
}]), (0,defineProperty/* default */.Z)(_accordionData, SectionWithAccordion.WAREHOUSES_ETL, [{
  title: "Syncing at scale",
  description: "Our warehouses pipeline syncs 6T rows each month across thousands of Snowflake, BigQuery, and Redshift warehouses."
}, {
  title: "Advanced Sync controls",
  description: "Our customizable scheduler ensures that loading queries don\u2019t block your analysis team. You can schedule at off-peak hours, or run overnight."
}, {
  title: "Multi-step failure recovery",
  description: "We run each part of our pipeline as an individual container job. Even if the last load step fails, we can re-run from the transformed dataset saving hours of sync time."
}, {
  title: "Type conversion",
  description: "We\u2019ll take free-form JSON and automatically convert it into whichever database types make the most sense pulled from our schema registry."
}, {
  title: "Schema management",
  description: "A warehouse is only as useful as the ability for analysts to query it. We materialize views of users and objects so that it is easy to join together data as part of a query and intuitive for analysts."
}]), _accordionData);
/* harmony default export */ var Infrastructure_accordionData = (accordionData);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Accordion/index.ts + 26 modules
var Accordion = __webpack_require__(83914);
// EXTERNAL MODULE: ../../libs/utils/useActiveState/index.ts + 1 modules
var useActiveState = __webpack_require__(74864);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/AccordionSection/AccordionSection.tsx


function AccordionSection_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var AccordionSection = function AccordionSection(_ref) {
  var section = _ref.section;
  var data = Infrastructure_accordionData[section];
  var items = new Array(data.length).fill(false);

  var _useActiveState = (0,useActiveState/* useActiveState */.z)(items, {
    allowMultipleActive: true
  }),
      activeItems = _useActiveState.activeItems,
      toggle = _useActiveState.toggle;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionSection_Wrapper, {
    children: activeItems.map(function (active, index) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* Header */.h4, {
          onClick: function onClick() {
            return toggle(index);
          },
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* TitleWrapper */.$t, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Title */.Dx, {
              variant: "h5",
              tag: "h4",
              opened: active,
              children: data[index].title
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Icon */.JO, {
            opened: active
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Body */.uT, {
          children: active && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* ContentWrapper */.vs, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionContent, {
              variant: "pMedium",
              dangerouslySetInnerHTML: {
                __html: sanitize_html_default()(data[index].description, {
                  allowedTags: ["a"]
                })
              }
            })
          })
        })]
      }, "item-".concat(index));
    })
  });
};

var AccordionSection_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ejf6pto1"
} : 0)( true ? {
  name: "inbvxe",
  styles: "overflow-y:hidden"
} : 0);

var AccordionContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "ejf6pto0"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);

/* harmony default export */ var AccordionSection_AccordionSection = (AccordionSection);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/CollectionLibraries/assets/CollectionLibraries@2x.png
var CollectionLibraries_2x = __webpack_require__(29251);
var CollectionLibraries_2x_default = /*#__PURE__*/__webpack_require__.n(CollectionLibraries_2x);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/CollectionLibraries/assets/CollectionLibraries.webp
var CollectionLibraries = __webpack_require__(23656);
var CollectionLibraries_default = /*#__PURE__*/__webpack_require__.n(CollectionLibraries);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/CollectionLibraries/assets/CollectionLibraries@2x.webp
var assets_CollectionLibraries_2x = __webpack_require__(69624);
var assets_CollectionLibraries_2x_default = /*#__PURE__*/__webpack_require__.n(assets_CollectionLibraries_2x);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/CollectionLibraries/CollectionLibrariesImage.tsx







var CollectionLibrariesImage = function CollectionLibrariesImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((CollectionLibraries_default()), ", ").concat((assets_CollectionLibraries_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "640",
      height: "607",
      src: (CollectionLibraries_2x_default()),
      alt: "CollectionLibraries",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var CollectionLibraries_CollectionLibrariesImage = (CollectionLibrariesImage);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/CollectionLibraries/CollectionLibraries.tsx


function CollectionLibraries_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var CollectionLibraries_data = {
  anchorId: "libraries",
  overline: "Collection",
  heading: "Libraries",
  description: "You need to collect customer data from your website and mobile apps tens of thousands of times per second. It should never crash and always work reliably. Here\u2019s how we do it\u2026",
  link: "https://github.com/segmentio/analytics.js",
  linkText: "segmentio/analytics.js (4,500 stars)",
  accordionSection: SectionWithAccordion.LIBRARIES
};

var CollectionLibraries_CollectionLibraries = function CollectionLibraries() {
  var anchorId = CollectionLibraries_data.anchorId,
      overline = CollectionLibraries_data.overline,
      heading = CollectionLibraries_data.heading,
      description = CollectionLibraries_data.description,
      link = CollectionLibraries_data.link,
      linkText = CollectionLibraries_data.linkText,
      accordionSection = CollectionLibraries_data.accordionSection;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionLibraries_Wrapper, {
    id: anchorId,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      copyVariant: "wide",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            children: heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* Description */.dk, {
            tag: "div",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionLibraries_CopyTextDescriptionSection, {
              children: description
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionLibraries_CopyTextDescriptionSection, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "pLarge",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                  href: link,
                  children: linkText
                })
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionSection_AccordionSection, {
              section: accordionSection
            })]
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionLibraries_CollectionLibrariesImage, {})
      })]
    })
  });
};

var CollectionLibraries_CopyTextDescriptionSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e18t8qbs1"
} : 0)( true ? {
  name: "1s22u92",
  styles: "margin-bottom:32px"
} : 0);

var CollectionLibraries_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e18t8qbs0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);

/* harmony default export */ var components_CollectionLibraries_CollectionLibraries = (CollectionLibraries_CollectionLibraries);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/CollectionCloudSources/assets/CollectionCloudSources@2x.png
var CollectionCloudSources_2x = __webpack_require__(90414);
var CollectionCloudSources_2x_default = /*#__PURE__*/__webpack_require__.n(CollectionCloudSources_2x);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/CollectionCloudSources/assets/CollectionCloudSources.webp
var CollectionCloudSources = __webpack_require__(24752);
var CollectionCloudSources_default = /*#__PURE__*/__webpack_require__.n(CollectionCloudSources);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/CollectionCloudSources/assets/CollectionCloudSources@2x.webp
var assets_CollectionCloudSources_2x = __webpack_require__(5784);
var assets_CollectionCloudSources_2x_default = /*#__PURE__*/__webpack_require__.n(assets_CollectionCloudSources_2x);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/CollectionCloudSources/CollectionCloudSourcesImage.tsx







var CollectionCloudSourcesImage = function CollectionCloudSourcesImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((CollectionCloudSources_default()), ", ").concat((assets_CollectionCloudSources_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "640",
      height: "335",
      src: (CollectionCloudSources_2x_default()),
      alt: "CollectionCloudSources",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var CollectionCloudSources_CollectionCloudSourcesImage = (CollectionCloudSourcesImage);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/CollectionCloudSources/CollectionCloudSources.tsx


function CollectionCloudSources_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var CollectionCloudSources_data = {
  anchorId: "cloud-sources",
  overline: "Collection",
  heading: "Cloud Sources",
  description: "To fully understand your users, you\u2019ll have to mirror the databases of your favorite SaaS tools (Adwords, Stripe, Salesforce, and more) into your systems of record. Here\u2019s how we do it\u2026",
  link: "https://news.ycombinator.com/item?id=11439725",
  linkText: "Segment Sources (37 comments)",
  accordionSection: SectionWithAccordion.CLOUD_SOURCES
};

var CollectionCloudSources_CollectionCloudSources = function CollectionCloudSources() {
  var anchorId = CollectionCloudSources_data.anchorId,
      overline = CollectionCloudSources_data.overline,
      heading = CollectionCloudSources_data.heading,
      description = CollectionCloudSources_data.description,
      link = CollectionCloudSources_data.link,
      linkText = CollectionCloudSources_data.linkText,
      accordionSection = CollectionCloudSources_data.accordionSection;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionCloudSources_Wrapper, {
    id: anchorId,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      copyVariant: "wide",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            children: heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* Description */.dk, {
            tag: "div",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionCloudSources_CopyTextDescriptionSection, {
              children: description
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionCloudSources_CopyTextDescriptionSection, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "pLarge",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                  href: link,
                  children: linkText
                })
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionSection_AccordionSection, {
              section: accordionSection
            })]
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionContents, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionCloudSources_CollectionCloudSourcesImage, {})
      })]
    })
  });
};

var CollectionCloudSources_CopyTextDescriptionSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "exaxgde2"
} : 0)( true ? {
  name: "1s22u92",
  styles: "margin-bottom:32px"
} : 0);

var CollectionCloudSources_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "exaxgde1"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);

var StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "exaxgde0"
} : 0)( true ? {
  name: "y1f223",
  styles: "margin:auto"
} : 0);

/* harmony default export */ var components_CollectionCloudSources_CollectionCloudSources = (CollectionCloudSources_CollectionCloudSources);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/CollectionSourceFunctions/assets/CollectionSourceFunctions@2x.png
var CollectionSourceFunctions_2x = __webpack_require__(50007);
var CollectionSourceFunctions_2x_default = /*#__PURE__*/__webpack_require__.n(CollectionSourceFunctions_2x);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/CollectionSourceFunctions/assets/CollectionSourceFunctions.webp
var CollectionSourceFunctions = __webpack_require__(62464);
var CollectionSourceFunctions_default = /*#__PURE__*/__webpack_require__.n(CollectionSourceFunctions);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/CollectionSourceFunctions/assets/CollectionSourceFunctions@2x.webp
var assets_CollectionSourceFunctions_2x = __webpack_require__(2104);
var assets_CollectionSourceFunctions_2x_default = /*#__PURE__*/__webpack_require__.n(assets_CollectionSourceFunctions_2x);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/CollectionSourceFunctions/CollectionSourceFunctionsImage.tsx







var CollectionSourceFunctionsImage = function CollectionSourceFunctionsImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((CollectionSourceFunctions_default()), ", ").concat((assets_CollectionSourceFunctions_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "640",
      height: "434",
      src: (CollectionSourceFunctions_2x_default()),
      alt: "Collection Source Functions",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var CollectionSourceFunctions_CollectionSourceFunctionsImage = (CollectionSourceFunctionsImage);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/CollectionSourceFunctions/CollectionSourceFunctions.tsx


function CollectionSourceFunctions_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var CollectionSourceFunctions_data = {
  anchorId: "source-functions",
  overline: "Collection",
  heading: "Source Functions",
  description: "Often, you\u2019ll want to pull in data from arbitrary web services or internal sources. They\u2019ll have webhooks for triggering new data entries, but no standardized way of getting that data. Here\u2019s how we do it\u2026",
  accordionSection: SectionWithAccordion.SOURCE_FUNCTIONS
};

var CollectionSourceFunctions_CollectionSourceFunctions = function CollectionSourceFunctions() {
  var anchorId = CollectionSourceFunctions_data.anchorId,
      overline = CollectionSourceFunctions_data.overline,
      heading = CollectionSourceFunctions_data.heading,
      description = CollectionSourceFunctions_data.description,
      accordionSection = CollectionSourceFunctions_data.accordionSection;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionSourceFunctions_Wrapper, {
    id: anchorId,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      copyVariant: "wide",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            children: heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* Description */.dk, {
            tag: "div",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionSourceFunctions_CopyTextDescriptionSection, {
              children: description
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionSection_AccordionSection, {
              section: accordionSection
            })]
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionSourceFunctions_StyledSectionContents, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionSourceFunctions_CollectionSourceFunctionsImage, {})
      })]
    })
  });
};

var CollectionSourceFunctions_CopyTextDescriptionSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e8zb6ru2"
} : 0)( true ? {
  name: "1s22u92",
  styles: "margin-bottom:32px"
} : 0);

var CollectionSourceFunctions_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e8zb6ru1"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);

var CollectionSourceFunctions_StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e8zb6ru0"
} : 0)( true ? {
  name: "y1f223",
  styles: "margin:auto"
} : 0);

/* harmony default export */ var components_CollectionSourceFunctions_CollectionSourceFunctions = (CollectionSourceFunctions_CollectionSourceFunctions);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/CollectionApi/assets/CollectionAPI@2x.png
var CollectionAPI_2x = __webpack_require__(98009);
var CollectionAPI_2x_default = /*#__PURE__*/__webpack_require__.n(CollectionAPI_2x);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/CollectionApi/assets/CollectionAPI.webp
var CollectionAPI = __webpack_require__(28268);
var CollectionAPI_default = /*#__PURE__*/__webpack_require__.n(CollectionAPI);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/CollectionApi/assets/CollectionAPI@2x.webp
var assets_CollectionAPI_2x = __webpack_require__(32387);
var assets_CollectionAPI_2x_default = /*#__PURE__*/__webpack_require__.n(assets_CollectionAPI_2x);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/CollectionApi/CollectionAPIImage.tsx







var CollectionAPIImage = function CollectionAPIImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((CollectionAPI_default()), ", ").concat((assets_CollectionAPI_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "640",
      height: "555",
      src: (CollectionAPI_2x_default()),
      alt: "Collection API",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var CollectionApi_CollectionAPIImage = (CollectionAPIImage);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/CollectionApi/CollectionAPI.tsx


function CollectionAPI_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var CollectionAPI_data = {
  anchorId: "api",
  overline: "Collection",
  heading: "API",
  description: "To collect all this data, you need an API that never goes down. We\u2019ve ensured that our high-performance Go servers are always available to accept new data. With a 30ms response time, and \u201Csix nines\u201D of availability, we\u2019re collecting 1M rps, handling spikes of 3-5x in minutes.",
  accordionSection: SectionWithAccordion.API
};

var CollectionAPI_CollectionAPI = function CollectionAPI() {
  var anchorId = CollectionAPI_data.anchorId,
      overline = CollectionAPI_data.overline,
      heading = CollectionAPI_data.heading,
      description = CollectionAPI_data.description,
      accordionSection = CollectionAPI_data.accordionSection;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionAPI_Wrapper, {
    id: anchorId,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      copyVariant: "wide",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            children: heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* Description */.dk, {
            tag: "div",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionAPI_CopyTextDescriptionSection, {
              children: description
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionSection_AccordionSection, {
              section: accordionSection
            })]
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionAPI_StyledSectionContents, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionApi_CollectionAPIImage, {})
      })]
    })
  });
};

var CollectionAPI_CopyTextDescriptionSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e12j124q2"
} : 0)( true ? {
  name: "1s22u92",
  styles: "margin-bottom:32px"
} : 0);

var CollectionAPI_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e12j124q1"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);

var CollectionAPI_StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e12j124q0"
} : 0)( true ? {
  name: "y1f223",
  styles: "margin:auto"
} : 0);

/* harmony default export */ var CollectionApi_CollectionAPI = (CollectionAPI_CollectionAPI);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/Processing/assets/Processing@2x.png
var Processing_2x = __webpack_require__(37795);
var Processing_2x_default = /*#__PURE__*/__webpack_require__.n(Processing_2x);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/Processing/assets/Processing.webp
var Processing = __webpack_require__(94714);
var Processing_default = /*#__PURE__*/__webpack_require__.n(Processing);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/Processing/assets/Processing@2x.webp
var assets_Processing_2x = __webpack_require__(75193);
var assets_Processing_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Processing_2x);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/Processing/ProcessingImage.tsx







var ProcessingImage = function ProcessingImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((Processing_default()), ", ").concat((assets_Processing_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "640",
      height: "424",
      src: (Processing_2x_default()),
      alt: "Processing",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var Processing_ProcessingImage = (ProcessingImage);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/Processing/Processing.tsx


function Processing_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var Processing_data = {
  heading: "Processing",
  section1: "Data can be messy. As anyone who has dealt with third-party APIs, JSON blobs, and semi-structured text knows that only 20-30% of your time is spent driving insights. Most of your time is spent cleaning the data you already have.",
  section2: "At minimum, you\u2019ll want to make sure your data infrastructure can:",
  section3: "<ul><li>Handle GDPR suppressions across millions of users</li>\n  <li>Validate and enforces arbitrary inputs</li>\n  <li>Allow you to transform and format individual events</li>\n  <li>Deduplicate retried requests</li></ul>",
  section4: "Here\u2019s how we do it."
};

var Processing_Processing = function Processing() {
  var heading = Processing_data.heading,
      section1 = Processing_data.section1,
      section2 = Processing_data.section2,
      section3 = Processing_data.section3,
      section4 = Processing_data.section4;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Processing_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      copyVariant: "wide",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            children: heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* Description */.dk, {
            tag: "div",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Processing_CopyTextDescriptionSection, {
              children: section1
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Processing_CopyTextDescriptionSection, {
              children: section2
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Processing_CopyTextDescriptionSection, {
              dangerouslySetInnerHTML: {
                __html: sanitize_html_default()(section3, {
                  allowedTags: ["ul", "li", "br"]
                })
              }
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Processing_CopyTextDescriptionSection, {
              children: section4
            })]
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Processing_ProcessingImage, {})
      })]
    })
  });
};

var Processing_CopyTextDescriptionSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1c002x81"
} : 0)( true ? {
  name: "1s22u92",
  styles: "margin-bottom:32px"
} : 0);

var Processing_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1c002x80"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);

/* harmony default export */ var components_Processing_Processing = (Processing_Processing);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/ProcessingValidationTransformation/assets/ProcessingValidationTransformation@2x.png
var ProcessingValidationTransformation_2x = __webpack_require__(18191);
var ProcessingValidationTransformation_2x_default = /*#__PURE__*/__webpack_require__.n(ProcessingValidationTransformation_2x);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/ProcessingValidationTransformation/assets/ProcessingValidationTransformation.webp
var ProcessingValidationTransformation = __webpack_require__(18023);
var ProcessingValidationTransformation_default = /*#__PURE__*/__webpack_require__.n(ProcessingValidationTransformation);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/ProcessingValidationTransformation/assets/ProcessingValidationTransformation@2x.webp
var assets_ProcessingValidationTransformation_2x = __webpack_require__(87939);
var assets_ProcessingValidationTransformation_2x_default = /*#__PURE__*/__webpack_require__.n(assets_ProcessingValidationTransformation_2x);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/ProcessingValidationTransformation/ProcessingValidationTransformationImage.tsx







var ProcessingValidationTransformationImage = function ProcessingValidationTransformationImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((ProcessingValidationTransformation_default()), ", ").concat((assets_ProcessingValidationTransformation_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "640",
      height: "524",
      src: (ProcessingValidationTransformation_2x_default()),
      alt: "Processing Validation Transformation",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var ProcessingValidationTransformation_ProcessingValidationTransformationImage = (ProcessingValidationTransformationImage);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/ProcessingValidationTransformation/ProcessingValidationTransformation.tsx


function ProcessingValidationTransformation_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var ProcessingValidationTransformation_data = {
  anchorId: "validation-and-transformation",
  overline: "Processing",
  heading: "Validation and Transformation",
  description: "Sometimes the data you\u2019re collecting isn\u2019t always in the format you want. It\u2019s important that anyone\u2014PMs, marketers, engineers\u2014be able to help clean the data you\u2019re collecting to match your needs.",
  link: "https://github.com/segmentio/encoding",
  linkText: "segmentio/encoding: Our zero-allocation JSON library (598 stars)",
  accordionSection: SectionWithAccordion.VALIDATION_AND_TRANSFORMATION
};

var ProcessingValidationTransformation_ProcessingValidationTransformation = function ProcessingValidationTransformation() {
  var anchorId = ProcessingValidationTransformation_data.anchorId,
      overline = ProcessingValidationTransformation_data.overline,
      heading = ProcessingValidationTransformation_data.heading,
      description = ProcessingValidationTransformation_data.description,
      link = ProcessingValidationTransformation_data.link,
      linkText = ProcessingValidationTransformation_data.linkText,
      accordionSection = ProcessingValidationTransformation_data.accordionSection;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProcessingValidationTransformation_Wrapper, {
    id: anchorId,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      copyVariant: "wide",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            children: heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* Description */.dk, {
            tag: "div",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProcessingValidationTransformation_CopyTextDescriptionSection, {
              children: description
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProcessingValidationTransformation_CopyTextDescriptionSection, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "pLarge",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                  href: link,
                  children: linkText
                })
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionSection_AccordionSection, {
              section: accordionSection
            })]
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProcessingValidationTransformation_StyledSectionContents, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProcessingValidationTransformation_ProcessingValidationTransformationImage, {})
      })]
    })
  });
};

var ProcessingValidationTransformation_CopyTextDescriptionSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "etus42h2"
} : 0)( true ? {
  name: "1s22u92",
  styles: "margin-bottom:32px"
} : 0);

var ProcessingValidationTransformation_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "etus42h1"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);

var ProcessingValidationTransformation_StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "etus42h0"
} : 0)( true ? {
  name: "y1f223",
  styles: "margin:auto"
} : 0);

/* harmony default export */ var components_ProcessingValidationTransformation_ProcessingValidationTransformation = (ProcessingValidationTransformation_ProcessingValidationTransformation);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/ProcessingDeduplication/assets/ProcessingDeduplication@2x.png
var ProcessingDeduplication_2x = __webpack_require__(47402);
var ProcessingDeduplication_2x_default = /*#__PURE__*/__webpack_require__.n(ProcessingDeduplication_2x);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/ProcessingDeduplication/assets/ProcessingDeduplication.webp
var ProcessingDeduplication = __webpack_require__(68444);
var ProcessingDeduplication_default = /*#__PURE__*/__webpack_require__.n(ProcessingDeduplication);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/ProcessingDeduplication/assets/ProcessingDeduplication@2x.webp
var assets_ProcessingDeduplication_2x = __webpack_require__(95672);
var assets_ProcessingDeduplication_2x_default = /*#__PURE__*/__webpack_require__.n(assets_ProcessingDeduplication_2x);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/ProcessingDeduplication/ProcessingDeduplicationImage.tsx







var ProcessingDeduplicationImage = function ProcessingDeduplicationImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((ProcessingDeduplication_default()), ", ").concat((assets_ProcessingDeduplication_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "640",
      height: "636",
      src: (ProcessingDeduplication_2x_default()),
      alt: "Processing Deduplication",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var ProcessingDeduplication_ProcessingDeduplicationImage = (ProcessingDeduplicationImage);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/ProcessingDeduplication/ProcessingDeduplication.tsx


function ProcessingDeduplication_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var getData = function getData(pageConfig) {
  return {
    anchorId: "deduplication",
    overline: "Processing",
    heading: "Deduplication",
    description: "What\u2019s worse than missing data? Duplicated data. It\u2019s impossible to trust your analysis if events show up 2, 3, or more times. That\u2019s why we\u2019ve invested heavily in our <a href=\"".concat((0,getAbsoluteUrl/* default */.Z)("https://segment.com/blog/exactly-once-delivery/", pageConfig), "\">Deduplication Infrastructure</a>. It reduces duplicate data by 0.6% over a 30d window."),
    link1: "https://news.ycombinator.com/item?id=14664405",
    link1Text: "Delivering billions of messages exactly once (133 Comments)",
    link2: "https://github.com/segmentio/kafka-go",
    link2Text: "segmentio/kafka-go (2,500 stars)",
    accordionSection: SectionWithAccordion.DEDUPLICATION
  };
};

var ProcessingDeduplication_ProcessingDeduplication = function ProcessingDeduplication() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var data = getData(pageConfig);
  var anchorId = data.anchorId,
      overline = data.overline,
      heading = data.heading,
      description = data.description,
      link1 = data.link1,
      link1Text = data.link1Text,
      link2 = data.link2,
      link2Text = data.link2Text,
      accordionSection = data.accordionSection;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProcessingDeduplication_Wrapper, {
    id: anchorId,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      copyVariant: "wide",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            children: heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* Description */.dk, {
            tag: "div",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProcessingDeduplication_CopyTextDescriptionSection, {
              dangerouslySetInnerHTML: {
                __html: sanitize_html_default()(description, {
                  allowedTags: ["a"]
                })
              }
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProcessingDeduplication_CopyTextDescriptionSection, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "pLarge",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                  href: link1,
                  children: link1Text
                })
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProcessingDeduplication_CopyTextDescriptionSection, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "pLarge",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                  href: link2,
                  children: link2Text
                })
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionSection_AccordionSection, {
              section: accordionSection
            })]
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProcessingDeduplication_StyledSectionContents, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProcessingDeduplication_ProcessingDeduplicationImage, {})
      })]
    })
  });
};

var ProcessingDeduplication_CopyTextDescriptionSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1b1fwd52"
} : 0)( true ? {
  name: "1s22u92",
  styles: "margin-bottom:32px"
} : 0);

var ProcessingDeduplication_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1b1fwd51"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);

var ProcessingDeduplication_StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e1b1fwd50"
} : 0)( true ? {
  name: "y1f223",
  styles: "margin:auto"
} : 0);

/* harmony default export */ var components_ProcessingDeduplication_ProcessingDeduplication = (ProcessingDeduplication_ProcessingDeduplication);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/ProcessingGdprSuppression/assets/ProcessingGDPRSuppression@2x.png
var ProcessingGDPRSuppression_2x = __webpack_require__(8100);
var ProcessingGDPRSuppression_2x_default = /*#__PURE__*/__webpack_require__.n(ProcessingGDPRSuppression_2x);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/ProcessingGdprSuppression/assets/ProcessingGDPRSuppression.webp
var ProcessingGDPRSuppression = __webpack_require__(56192);
var ProcessingGDPRSuppression_default = /*#__PURE__*/__webpack_require__.n(ProcessingGDPRSuppression);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/ProcessingGdprSuppression/assets/ProcessingGDPRSuppression@2x.webp
var assets_ProcessingGDPRSuppression_2x = __webpack_require__(35035);
var assets_ProcessingGDPRSuppression_2x_default = /*#__PURE__*/__webpack_require__.n(assets_ProcessingGDPRSuppression_2x);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/ProcessingGdprSuppression/ProcessingGDPRSuppressionImage.tsx







var ProcessingGDPRSuppressionImage = function ProcessingGDPRSuppressionImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((ProcessingGDPRSuppression_default()), ", ").concat((assets_ProcessingGDPRSuppression_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "640",
      height: "636",
      src: (ProcessingGDPRSuppression_2x_default()),
      alt: "Processing GDPR Suppression",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var ProcessingGdprSuppression_ProcessingGDPRSuppressionImage = (ProcessingGDPRSuppressionImage);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/ProcessingGdprSuppression/ProcessingGDPRSuppression.tsx


function ProcessingGDPRSuppression_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var ProcessingGDPRSuppression_data = {
  anchorId: "gdpr-suppression-and-deletion",
  overline: "Processing",
  heading: "GDPR Suppression and Deletion",
  description: "If you\u2019re working with data today, you must be compliant with the GDPR and CCPA. Both grant individual users the ability to request that their data be deleted or suppressed. It\u2019s sort of like finding 100k needles in 100 billion haystacks\u2014but here\u2019s how we do it.",
  buttonTextLink: "/product/gdpr/",
  buttonTextLinkText: "Learn more",
  accordionSection: SectionWithAccordion.GDPR_SUPPRESSION
};

var ProcessingGDPRSuppression_ProcessingGDPRSuppression = function ProcessingGDPRSuppression() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var anchorId = ProcessingGDPRSuppression_data.anchorId,
      overline = ProcessingGDPRSuppression_data.overline,
      heading = ProcessingGDPRSuppression_data.heading,
      description = ProcessingGDPRSuppression_data.description,
      buttonTextLink = ProcessingGDPRSuppression_data.buttonTextLink,
      buttonTextLinkText = ProcessingGDPRSuppression_data.buttonTextLinkText,
      accordionSection = ProcessingGDPRSuppression_data.accordionSection;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProcessingGDPRSuppression_Wrapper, {
    id: anchorId,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      copyVariant: "wide",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            children: heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "div",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Spacer, {
              children: description
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Spacer, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
              tag: "a",
              href: (0,getAbsoluteUrl/* default */.Z)(buttonTextLink, pageConfig),
              iconEnd: Common/* ChevronRightIcon */.XC,
              children: buttonTextLinkText
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionSection_AccordionSection, {
            section: accordionSection
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProcessingGDPRSuppression_StyledSectionContents, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProcessingGdprSuppression_ProcessingGDPRSuppressionImage, {})
      })]
    })
  });
};

var Spacer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e19gw22r2"
} : 0)( true ? {
  name: "1s22u92",
  styles: "margin-bottom:32px"
} : 0);

var ProcessingGDPRSuppression_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e19gw22r1"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);

var ProcessingGDPRSuppression_StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e19gw22r0"
} : 0)( true ? {
  name: "y1f223",
  styles: "margin:auto"
} : 0);

/* harmony default export */ var ProcessingGdprSuppression_ProcessingGDPRSuppression = (ProcessingGDPRSuppression_ProcessingGDPRSuppression);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/Aggregation/assets/Aggregation@2x.png
var Aggregation_2x = __webpack_require__(74178);
var Aggregation_2x_default = /*#__PURE__*/__webpack_require__.n(Aggregation_2x);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/Aggregation/assets/Aggregation.webp
var Aggregation = __webpack_require__(56147);
var Aggregation_default = /*#__PURE__*/__webpack_require__.n(Aggregation);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/Aggregation/assets/Aggregation@2x.webp
var assets_Aggregation_2x = __webpack_require__(40572);
var assets_Aggregation_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Aggregation_2x);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/Aggregation/AggregationImage.tsx







var AggregationImage = function AggregationImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((Aggregation_default()), ", ").concat((assets_Aggregation_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "640",
      height: "646",
      src: (Aggregation_2x_default()),
      alt: "Aggregation",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var Aggregation_AggregationImage = (AggregationImage);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/Aggregation/Aggregation.tsx


function Aggregation_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var Aggregation_data = {
  heading: "Aggregation",
  section1: "Individual events don\u2019t tell the full story of a user. For that, you need to combine that data all into the notion of a single profile.",
  section2: "This is where most systems hit their scaling limits. Not only do they need to process tens of thousands of events per second, but they need to route that data to a single partition. This requires:",
  section3: "<ul><li>Querying a single profile in real-time in milliseconds</li>\n  <li>Scanning across millions of user histories to find a small group</li></ul>",
  section4: "Here\u2019s how we do it.",
  link: "https://www.youtube.com/watch?v=rECHcoGIJNU",
  linkText: "Watch on Youtube (2,600 views)"
};

var Aggregation_Aggregation = function Aggregation() {
  var heading = Aggregation_data.heading,
      section1 = Aggregation_data.section1,
      section2 = Aggregation_data.section2,
      section3 = Aggregation_data.section3,
      section4 = Aggregation_data.section4,
      link = Aggregation_data.link,
      linkText = Aggregation_data.linkText;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Aggregation_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      copyVariant: "wide",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            children: heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* Description */.dk, {
            tag: "div",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Aggregation_CopyTextDescriptionSection, {
              children: section1
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Aggregation_CopyTextDescriptionSection, {
              children: section2
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Aggregation_CopyTextDescriptionSection, {
              dangerouslySetInnerHTML: {
                __html: sanitize_html_default()(section3, {
                  allowedTags: ["ul", "li", "br"]
                })
              }
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Aggregation_CopyTextDescriptionSection, {
              children: section4
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Aggregation_CopyTextDescriptionSection, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "pLarge",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                  href: link,
                  children: linkText
                })
              })
            })]
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Aggregation_AggregationImage, {})
      })]
    })
  });
};

var Aggregation_CopyTextDescriptionSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1p1ek1v1"
} : 0)( true ? {
  name: "1s22u92",
  styles: "margin-bottom:32px"
} : 0);

var Aggregation_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1p1ek1v0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);

/* harmony default export */ var components_Aggregation_Aggregation = (Aggregation_Aggregation);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/AggregationIdentityResolution/assets/AggregationIdentityResolution@2x.png
var AggregationIdentityResolution_2x = __webpack_require__(74013);
var AggregationIdentityResolution_2x_default = /*#__PURE__*/__webpack_require__.n(AggregationIdentityResolution_2x);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/AggregationIdentityResolution/assets/AggregationIdentityResolution.webp
var AggregationIdentityResolution = __webpack_require__(81952);
var AggregationIdentityResolution_default = /*#__PURE__*/__webpack_require__.n(AggregationIdentityResolution);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/AggregationIdentityResolution/assets/AggregationIdentityResolution@2x.webp
var assets_AggregationIdentityResolution_2x = __webpack_require__(26186);
var assets_AggregationIdentityResolution_2x_default = /*#__PURE__*/__webpack_require__.n(assets_AggregationIdentityResolution_2x);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/AggregationIdentityResolution/AggregationIdentityResolutionImage.tsx







var AggregationIdentityResolutionImage = function AggregationIdentityResolutionImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((AggregationIdentityResolution_default()), ", ").concat((assets_AggregationIdentityResolution_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "640",
      height: "810",
      src: (AggregationIdentityResolution_2x_default()),
      alt: "Aggregation Identity Resolution",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var AggregationIdentityResolution_AggregationIdentityResolutionImage = (AggregationIdentityResolutionImage);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/AggregationIdentityResolution/AggregationIdentityResolution.tsx


function AggregationIdentityResolution_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var AggregationIdentityResolution_data = {
  anchorId: "identity-resolution",
  overline: "Aggregation",
  heading: "Identity Resolution",
  description: "Emails, device IDs, primary keys in your database, account IDs\u2014a single user might be keyed in hundreds of different ways! You can\u2019t just overwrite those ties or endlessly traverse cycles in your identity graph. You need a bullet-proof system for tying those users together. Here\u2019s how we do it.",
  buttonTextLink: "https://segment.com/blog/identity-resolution/",
  buttonTextLinkText: "Read our blog",
  accordionSection: SectionWithAccordion.IDENTITY_RESOLUTION
};

var AggregationIdentityResolution_AggregationIdentityResolution = function AggregationIdentityResolution() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var anchorId = AggregationIdentityResolution_data.anchorId,
      overline = AggregationIdentityResolution_data.overline,
      heading = AggregationIdentityResolution_data.heading,
      description = AggregationIdentityResolution_data.description,
      buttonTextLink = AggregationIdentityResolution_data.buttonTextLink,
      buttonTextLinkText = AggregationIdentityResolution_data.buttonTextLinkText,
      accordionSection = AggregationIdentityResolution_data.accordionSection;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AggregationIdentityResolution_Wrapper, {
    id: anchorId,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      copyVariant: "wide",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            children: heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "div",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AggregationIdentityResolution_Spacer, {
              children: description
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AggregationIdentityResolution_Spacer, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
              tag: "a",
              href: (0,getAbsoluteUrl/* default */.Z)(buttonTextLink, pageConfig),
              iconEnd: Common/* ChevronRightIcon */.XC,
              children: buttonTextLinkText
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionSection_AccordionSection, {
            section: accordionSection
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AggregationIdentityResolution_StyledSectionContents, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AggregationIdentityResolution_AggregationIdentityResolutionImage, {})
      })]
    })
  });
};

var AggregationIdentityResolution_Spacer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e13kowqt2"
} : 0)( true ? {
  name: "1s22u92",
  styles: "margin-bottom:32px"
} : 0);

var AggregationIdentityResolution_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e13kowqt1"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);

var AggregationIdentityResolution_StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e13kowqt0"
} : 0)( true ? {
  name: "y1f223",
  styles: "margin:auto"
} : 0);

/* harmony default export */ var components_AggregationIdentityResolution_AggregationIdentityResolution = (AggregationIdentityResolution_AggregationIdentityResolution);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/AggregationProfileApi/assets/AggregationProfileAPI@2x.png
var AggregationProfileAPI_2x = __webpack_require__(54174);
var AggregationProfileAPI_2x_default = /*#__PURE__*/__webpack_require__.n(AggregationProfileAPI_2x);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/AggregationProfileApi/assets/AggregationProfileAPI.webp
var AggregationProfileAPI = __webpack_require__(38247);
var AggregationProfileAPI_default = /*#__PURE__*/__webpack_require__.n(AggregationProfileAPI);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/AggregationProfileApi/assets/AggregationProfileAPI@2x.webp
var assets_AggregationProfileAPI_2x = __webpack_require__(82300);
var assets_AggregationProfileAPI_2x_default = /*#__PURE__*/__webpack_require__.n(assets_AggregationProfileAPI_2x);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/AggregationProfileApi/AggregationProfileAPIImage.tsx







var AggregationProfileAPIImage = function AggregationProfileAPIImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((AggregationProfileAPI_default()), ", ").concat((assets_AggregationProfileAPI_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "640",
      height: "524",
      src: (AggregationProfileAPI_2x_default()),
      alt: "Aggregation Profile API",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var AggregationProfileApi_AggregationProfileAPIImage = (AggregationProfileAPIImage);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/AggregationProfileApi/AggregationProfileAPI.tsx


function AggregationProfileAPI_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var AggregationProfileAPI_data = {
  anchorId: "profile-api",
  overline: "Aggregation",
  heading: "Profile API",
  description: "Personalizing your website isn\u2019t easy. You need millisecond response times to be able to get the page to load quickly. You need a full event history of your user. And you need to be able to make those decisions as the page is loading. Here\u2019s how we do it.",
  link: "https://www.youtube.com/watch?v=rECHcoGIJNU",
  linkText: "Watch on Youtube (2,600 views)",
  accordionSection: SectionWithAccordion.PROFILE_API
};

var AggregationProfileAPI_AggregationProfileAPI = function AggregationProfileAPI() {
  var anchorId = AggregationProfileAPI_data.anchorId,
      overline = AggregationProfileAPI_data.overline,
      heading = AggregationProfileAPI_data.heading,
      description = AggregationProfileAPI_data.description,
      link = AggregationProfileAPI_data.link,
      linkText = AggregationProfileAPI_data.linkText,
      accordionSection = AggregationProfileAPI_data.accordionSection;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AggregationProfileAPI_Wrapper, {
    id: anchorId,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      copyVariant: "wide",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            children: heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* Description */.dk, {
            tag: "div",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AggregationProfileAPI_CopyTextDescriptionSection, {
              children: description
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AggregationProfileAPI_CopyTextDescriptionSection, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "pLarge",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                  href: link,
                  children: linkText
                })
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionSection_AccordionSection, {
              section: accordionSection
            })]
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AggregationProfileAPI_StyledSectionContents, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AggregationProfileApi_AggregationProfileAPIImage, {})
      })]
    })
  });
};

var AggregationProfileAPI_CopyTextDescriptionSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eirxr112"
} : 0)( true ? {
  name: "1s22u92",
  styles: "margin-bottom:32px"
} : 0);

var AggregationProfileAPI_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "eirxr111"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);

var AggregationProfileAPI_StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "eirxr110"
} : 0)( true ? {
  name: "y1f223",
  styles: "margin:auto"
} : 0);

/* harmony default export */ var AggregationProfileApi_AggregationProfileAPI = (AggregationProfileAPI_AggregationProfileAPI);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/AggregationReverseEtl/assets/AggregationReverseETL@2x.png
var AggregationReverseETL_2x = __webpack_require__(41287);
var AggregationReverseETL_2x_default = /*#__PURE__*/__webpack_require__.n(AggregationReverseETL_2x);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/AggregationReverseEtl/assets/AggregationReverseETL.webp
var AggregationReverseETL = __webpack_require__(8263);
var AggregationReverseETL_default = /*#__PURE__*/__webpack_require__.n(AggregationReverseETL);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/AggregationReverseEtl/assets/AggregationReverseETL@2x.webp
var assets_AggregationReverseETL_2x = __webpack_require__(29131);
var assets_AggregationReverseETL_2x_default = /*#__PURE__*/__webpack_require__.n(assets_AggregationReverseETL_2x);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/AggregationReverseEtl/AggregationReverseETLImage.tsx







var AggregationReverseETLImage = function AggregationReverseETLImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((AggregationReverseETL_default()), ", ").concat((assets_AggregationReverseETL_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "640",
      height: "427",
      src: (AggregationReverseETL_2x_default()),
      alt: "Aggregation Reverse ETL",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var AggregationReverseEtl_AggregationReverseETLImage = (AggregationReverseETLImage);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/AggregationReverseEtl/AggregationReverseETL.tsx


function AggregationReverseETL_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var AggregationReverseETL_data = {
  anchorId: "reverse-etl",
  overline: "Warehouse data activation",
  heading: "Reverse ETL",
  description: "Bring enriched data from your warehouse and activate it anywhere. Reverse ETL makes it easy for data teams to get marketers access to the data they need to build.",
  buttonTextLink: "/product/reverse-etl/",
  buttonTextLinkText: "Explore Reverse ETL",
  accordionSection: SectionWithAccordion.REVERSE_ETL
};

var AggregationReverseETL_AggregationReverseETL = function AggregationReverseETL() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var anchorId = AggregationReverseETL_data.anchorId,
      overline = AggregationReverseETL_data.overline,
      heading = AggregationReverseETL_data.heading,
      description = AggregationReverseETL_data.description,
      buttonTextLink = AggregationReverseETL_data.buttonTextLink,
      buttonTextLinkText = AggregationReverseETL_data.buttonTextLinkText,
      accordionSection = AggregationReverseETL_data.accordionSection;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AggregationReverseETL_Wrapper, {
    id: anchorId,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      copyVariant: "wide",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            children: heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "div",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AggregationReverseETL_Spacer, {
              children: description
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionSection_AccordionSection, {
            section: accordionSection
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopSpacer, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
              tag: "a",
              href: (0,getAbsoluteUrl/* default */.Z)(buttonTextLink, pageConfig),
              iconEnd: Common/* ChevronRightIcon */.XC,
              children: buttonTextLinkText
            })
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AggregationReverseETL_StyledSectionContents, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AggregationReverseEtl_AggregationReverseETLImage, {})
      })]
    })
  });
};

var TopSpacer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e18sybdd3"
} : 0)( true ? {
  name: "3hgi0y",
  styles: "margin-top:32px"
} : 0);

var AggregationReverseETL_Spacer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e18sybdd2"
} : 0)( true ? {
  name: "1s22u92",
  styles: "margin-bottom:32px"
} : 0);

var AggregationReverseETL_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e18sybdd1"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);

var AggregationReverseETL_StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e18sybdd0"
} : 0)( true ? {
  name: "y1f223",
  styles: "margin:auto"
} : 0);

/* harmony default export */ var AggregationReverseEtl_AggregationReverseETL = (AggregationReverseETL_AggregationReverseETL);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/AggregationAudienceCreation/assets/AggregationAudienceCreation@2x.png
var AggregationAudienceCreation_2x = __webpack_require__(4958);
var AggregationAudienceCreation_2x_default = /*#__PURE__*/__webpack_require__.n(AggregationAudienceCreation_2x);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/AggregationAudienceCreation/assets/AggregationAudienceCreation.webp
var AggregationAudienceCreation = __webpack_require__(90071);
var AggregationAudienceCreation_default = /*#__PURE__*/__webpack_require__.n(AggregationAudienceCreation);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/AggregationAudienceCreation/assets/AggregationAudienceCreation@2x.webp
var assets_AggregationAudienceCreation_2x = __webpack_require__(74651);
var assets_AggregationAudienceCreation_2x_default = /*#__PURE__*/__webpack_require__.n(assets_AggregationAudienceCreation_2x);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/AggregationAudienceCreation/AggregationAudienceCreationImage.tsx







var AggregationAudienceCreationImage = function AggregationAudienceCreationImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((AggregationAudienceCreation_default()), ", ").concat((assets_AggregationAudienceCreation_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "1102",
      height: "657",
      src: (AggregationAudienceCreation_2x_default()),
      alt: "Aggregation Audience Creation",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var AggregationAudienceCreation_AggregationAudienceCreationImage = (AggregationAudienceCreationImage);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/AggregationAudienceCreation/AggregationAudienceCreation.tsx


function AggregationAudienceCreation_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var AggregationAudienceCreation_data = {
  anchorId: "audience-creation",
  overline: "Aggregation",
  heading: "Audience Creation",
  description: "Searching through billions of user actions to find who loaded a particular page more than 3 times in a month isn\u2019t easy. You have to run complex aggregations, set up your data structure so they can be quickly and efficiently queried, and run it all on core infra.",
  link: "https://www.youtube.com/watch?v=rECHcoGIJNU",
  linkText: "Watch on Youtube (2,600 views)",
  accordionSection: SectionWithAccordion.AUDIENCE_CREATION
};

var AggregationAudienceCreation_AggregationAudienceCreation = function AggregationAudienceCreation() {
  var anchorId = AggregationAudienceCreation_data.anchorId,
      overline = AggregationAudienceCreation_data.overline,
      heading = AggregationAudienceCreation_data.heading,
      description = AggregationAudienceCreation_data.description,
      link = AggregationAudienceCreation_data.link,
      linkText = AggregationAudienceCreation_data.linkText,
      accordionSection = AggregationAudienceCreation_data.accordionSection;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AggregationAudienceCreation_Wrapper, {
    id: anchorId,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      copyVariant: "wide",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            children: heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* Description */.dk, {
            tag: "div",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AggregationAudienceCreation_CopyTextDescriptionSection, {
              children: description
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AggregationAudienceCreation_CopyTextDescriptionSection, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "pLarge",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                  href: link,
                  children: linkText
                })
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionSection_AccordionSection, {
              section: accordionSection
            })]
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AggregationAudienceCreation_StyledSectionContents, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AggregationAudienceCreation_AggregationAudienceCreationImage, {})
      })]
    })
  });
};

var AggregationAudienceCreation_CopyTextDescriptionSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ecs33da2"
} : 0)( true ? {
  name: "1s22u92",
  styles: "margin-bottom:32px"
} : 0);

var AggregationAudienceCreation_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "ecs33da1"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);

var AggregationAudienceCreation_StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "ecs33da0"
} : 0)( true ? {
  name: "y1f223",
  styles: "margin:auto"
} : 0);

/* harmony default export */ var components_AggregationAudienceCreation_AggregationAudienceCreation = (AggregationAudienceCreation_AggregationAudienceCreation);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/Delivery/assets/Delivery@2x.png
var Delivery_2x = __webpack_require__(57076);
var Delivery_2x_default = /*#__PURE__*/__webpack_require__.n(Delivery_2x);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/Delivery/assets/Delivery.webp
var Delivery = __webpack_require__(98443);
var Delivery_default = /*#__PURE__*/__webpack_require__.n(Delivery);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/Delivery/assets/Delivery@2x.webp
var assets_Delivery_2x = __webpack_require__(10457);
var assets_Delivery_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Delivery_2x);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/Delivery/DeliveryImage.tsx







var DeliveryImage = function DeliveryImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((Delivery_default()), ", ").concat((assets_Delivery_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "640",
      height: "1071",
      src: (Delivery_2x_default()),
      alt: "Delivery",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var Delivery_DeliveryImage = (DeliveryImage);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/Delivery/Delivery.tsx


function Delivery_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var Delivery_data = {
  heading: "Delivery",
  section1: "Once you finally have data in one spot, there\u2019s one last step\u2014using that data. That means getting it into all of the different consumers and end tools.",
  section2: "In a controlled environment, this is easy. But over the open internet, it\u2019s anything but.",
  section3: "You\u2019re connecting to dozens of APIs. What if one fails? What if it gets slow? What if an API mysteriously changes? How do you ensure nothing goes missing?",
  section4: "You have all sorts of semi-structured data. How do you map it into structured forms like a data lake or a data warehouse.",
  section5: "It\u2019s not easy, but here\u2019s how we\u2019ve built it.",
  link1: "https://segment.com/blog/introducing-centrifuge/",
  link1Text: "Centrifuge: a reliable system for delivering billions of events per day (65 comments)",
  link2: "https://news.ycombinator.com/item?id=17499137",
  link2Text: "Goodbye microservices (753 comments)",
  link3: "https://github.com/segmentio/kafka-go",
  link3Text: "segmentio/kafka-go (2,500 stars)"
};

var Delivery_Delivery = function Delivery() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var heading = Delivery_data.heading,
      section1 = Delivery_data.section1,
      section2 = Delivery_data.section2,
      section3 = Delivery_data.section3,
      section4 = Delivery_data.section4,
      section5 = Delivery_data.section5,
      link1 = Delivery_data.link1,
      link1Text = Delivery_data.link1Text,
      link2 = Delivery_data.link2,
      link2Text = Delivery_data.link2Text,
      link3 = Delivery_data.link3,
      link3Text = Delivery_data.link3Text;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Delivery_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      copyVariant: "wide",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            children: heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* Description */.dk, {
            tag: "div",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Delivery_CopyTextDescriptionSection, {
              children: section1
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Delivery_CopyTextDescriptionSection, {
              children: section2
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Delivery_CopyTextDescriptionSection, {
              children: section3
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Delivery_CopyTextDescriptionSection, {
              children: section4
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Delivery_CopyTextDescriptionSection, {
              children: section5
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Delivery_CopyTextDescriptionSection, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "pLarge",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                  href: (0,getAbsoluteUrl/* default */.Z)(link1, pageConfig),
                  children: link1Text
                })
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Delivery_CopyTextDescriptionSection, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "pLarge",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                  href: link2,
                  children: link2Text
                })
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Delivery_CopyTextDescriptionSection, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "pLarge",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                  href: link3,
                  children: link3Text
                })
              })
            })]
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Delivery_DeliveryImage, {})
      })]
    })
  });
};

var Delivery_CopyTextDescriptionSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ehlda791"
} : 0)( true ? {
  name: "1s22u92",
  styles: "margin-bottom:32px"
} : 0);

var Delivery_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "ehlda790"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);

/* harmony default export */ var components_Delivery_Delivery = (Delivery_Delivery);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/DeliveryCentrifuge/assets/DeliveryCentrifuge@2x.png
var DeliveryCentrifuge_2x = __webpack_require__(34590);
var DeliveryCentrifuge_2x_default = /*#__PURE__*/__webpack_require__.n(DeliveryCentrifuge_2x);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/DeliveryCentrifuge/assets/DeliveryCentrifuge.webp
var DeliveryCentrifuge = __webpack_require__(27612);
var DeliveryCentrifuge_default = /*#__PURE__*/__webpack_require__.n(DeliveryCentrifuge);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/DeliveryCentrifuge/assets/DeliveryCentrifuge@2x.webp
var assets_DeliveryCentrifuge_2x = __webpack_require__(84605);
var assets_DeliveryCentrifuge_2x_default = /*#__PURE__*/__webpack_require__.n(assets_DeliveryCentrifuge_2x);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/DeliveryCentrifuge/DeliveryCentrifugeImage.tsx







var DeliveryCentrifugeImage = function DeliveryCentrifugeImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((DeliveryCentrifuge_default()), ", ").concat((assets_DeliveryCentrifuge_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "640",
      height: "391",
      src: (DeliveryCentrifuge_2x_default()),
      alt: "Delivery Centrifuge",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var DeliveryCentrifuge_DeliveryCentrifugeImage = (DeliveryCentrifugeImage);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/DeliveryCentrifuge/DeliveryCentrifuge.tsx


function DeliveryCentrifuge_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var DeliveryCentrifuge_getData = function getData(pageConfig) {
  return {
    anchorId: "centrifuge",
    overline: "Delivery",
    heading: "Centrifuge",
    description: "APIs fail. At any given time, we see dozens of endpoints timing out, returning 5xx errors, or connection resets. We built <a href=\"".concat((0,getAbsoluteUrl/* default */.Z)("https://segment.com/blog/introducing-centrifuge/", pageConfig), "\">Centrifuge</a>, infrastructure to reliably retry and deliver messages even in cases of extreme failure. It brings up our message delivery by 1.5% on average."),
    link1: (0,getAbsoluteUrl/* default */.Z)("https://segment.com/blog/introducing-centrifuge/", pageConfig),
    link1Text: "Centrifuge: a reliable system for delivering billions of events per day (65 comments)",
    link2: "https://github.com/segmentio/kafka-go",
    link2Text: "segmentio/kafka-go (2,500 stars)",
    accordionSection: SectionWithAccordion.CENTRIFUGE
  };
};

var DeliveryCentrifuge_DeliveryCentrifuge = function DeliveryCentrifuge() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();

  var _getData = DeliveryCentrifuge_getData(pageConfig),
      anchorId = _getData.anchorId,
      overline = _getData.overline,
      heading = _getData.heading,
      description = _getData.description,
      link1 = _getData.link1,
      link1Text = _getData.link1Text,
      link2 = _getData.link2,
      link2Text = _getData.link2Text,
      accordionSection = _getData.accordionSection;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeliveryCentrifuge_Wrapper, {
    id: anchorId,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      copyVariant: "wide",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            children: heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* Description */.dk, {
            tag: "div",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeliveryCentrifuge_CopyTextDescriptionSection, {
              dangerouslySetInnerHTML: {
                __html: sanitize_html_default()(description, {
                  allowedTags: ["a"]
                })
              }
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeliveryCentrifuge_CopyTextDescriptionSection, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "pLarge",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                  href: link1,
                  children: link1Text
                })
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeliveryCentrifuge_CopyTextDescriptionSection, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "pLarge",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                  href: link2,
                  children: link2Text
                })
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionSection_AccordionSection, {
              section: accordionSection
            })]
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeliveryCentrifuge_StyledSectionContents, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeliveryCentrifuge_DeliveryCentrifugeImage, {})
      })]
    })
  });
};

var DeliveryCentrifuge_CopyTextDescriptionSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "es3qhbs2"
} : 0)( true ? {
  name: "1s22u92",
  styles: "margin-bottom:32px"
} : 0);

var DeliveryCentrifuge_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "es3qhbs1"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);

var DeliveryCentrifuge_StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "es3qhbs0"
} : 0)( true ? {
  name: "y1f223",
  styles: "margin:auto"
} : 0);

/* harmony default export */ var components_DeliveryCentrifuge_DeliveryCentrifuge = (DeliveryCentrifuge_DeliveryCentrifuge);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/DeliveryDestinations/assets/DeliveryDestinations@2x.png
var DeliveryDestinations_2x = __webpack_require__(98370);
var DeliveryDestinations_2x_default = /*#__PURE__*/__webpack_require__.n(DeliveryDestinations_2x);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/DeliveryDestinations/assets/DeliveryDestinations.webp
var DeliveryDestinations = __webpack_require__(21976);
var DeliveryDestinations_default = /*#__PURE__*/__webpack_require__.n(DeliveryDestinations);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/DeliveryDestinations/assets/DeliveryDestinations@2x.webp
var assets_DeliveryDestinations_2x = __webpack_require__(61166);
var assets_DeliveryDestinations_2x_default = /*#__PURE__*/__webpack_require__.n(assets_DeliveryDestinations_2x);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/DeliveryDestinations/DeliveryDestinationsImage.tsx







var DeliveryDestinationsImage = function DeliveryDestinationsImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((DeliveryDestinations_default()), ", ").concat((assets_DeliveryDestinations_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "640",
      height: "479",
      src: (DeliveryDestinations_2x_default()),
      alt: "Delivery Destinations",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var DeliveryDestinations_DeliveryDestinationsImage = (DeliveryDestinationsImage);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/DeliveryDestinations/DeliveryDestinations.tsx


function DeliveryDestinations_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var DeliveryDestinations_data = {
  anchorId: "destinations",
  overline: "Delivery",
  heading: "Destinations",
  description: "Writing integrations is fussy. There\u2019s new APIs to learn, tricky XML and JSON parsing, authentication refreshes, and mapping little bits of data. Often these APIs have little documentation and unexpected error codes. We\u2019ve built out our destinations to handle all of these tiny inconsistencies at scale.",
  link1: "https://news.ycombinator.com/item?id=17499137",
  link1Text: "Goodbye microservices (753 comments)",
  link2: "https://news.ycombinator.com/item?id=19106767",
  link2Text: "When AWS Autoscale Doesn\u2019t (92 comments)",
  accordionSection: SectionWithAccordion.DESTINATIONS
};

var DeliveryDestinations_DeliveryDestinations = function DeliveryDestinations() {
  var anchorId = DeliveryDestinations_data.anchorId,
      overline = DeliveryDestinations_data.overline,
      heading = DeliveryDestinations_data.heading,
      description = DeliveryDestinations_data.description,
      link1 = DeliveryDestinations_data.link1,
      link1Text = DeliveryDestinations_data.link1Text,
      link2 = DeliveryDestinations_data.link2,
      link2Text = DeliveryDestinations_data.link2Text,
      accordionSection = DeliveryDestinations_data.accordionSection;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeliveryDestinations_Wrapper, {
    id: anchorId,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      copyVariant: "wide",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            children: heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* Description */.dk, {
            tag: "div",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeliveryDestinations_CopyTextDescriptionSection, {
              children: description
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeliveryDestinations_CopyTextDescriptionSection, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "pLarge",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                  href: link1,
                  children: link1Text
                })
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeliveryDestinations_CopyTextDescriptionSection, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "pLarge",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                  href: link2,
                  children: link2Text
                })
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionSection_AccordionSection, {
              section: accordionSection
            })]
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeliveryDestinations_StyledSectionContents, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeliveryDestinations_DeliveryDestinationsImage, {})
      })]
    })
  });
};

var DeliveryDestinations_CopyTextDescriptionSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ia61i52"
} : 0)( true ? {
  name: "1s22u92",
  styles: "margin-bottom:32px"
} : 0);

var DeliveryDestinations_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1ia61i51"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);

var DeliveryDestinations_StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e1ia61i50"
} : 0)( true ? {
  name: "y1f223",
  styles: "margin:auto"
} : 0);

/* harmony default export */ var components_DeliveryDestinations_DeliveryDestinations = (DeliveryDestinations_DeliveryDestinations);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/DeliveryWarehousesEtl/assets/DeliveryWarehousesETL@2x.png
var DeliveryWarehousesETL_2x = __webpack_require__(52273);
var DeliveryWarehousesETL_2x_default = /*#__PURE__*/__webpack_require__.n(DeliveryWarehousesETL_2x);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/DeliveryWarehousesEtl/assets/DeliveryWarehousesETL.webp
var DeliveryWarehousesETL = __webpack_require__(20584);
var DeliveryWarehousesETL_default = /*#__PURE__*/__webpack_require__.n(DeliveryWarehousesETL);
// EXTERNAL MODULE: ./src/views/Infrastructure/components/DeliveryWarehousesEtl/assets/DeliveryWarehousesETL@2x.webp
var assets_DeliveryWarehousesETL_2x = __webpack_require__(52247);
var assets_DeliveryWarehousesETL_2x_default = /*#__PURE__*/__webpack_require__.n(assets_DeliveryWarehousesETL_2x);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/DeliveryWarehousesEtl/DeliveryWarehousesETLImage.tsx







var DeliveryWarehousesETLImage = function DeliveryWarehousesETLImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((DeliveryWarehousesETL_default()), ", ").concat((assets_DeliveryWarehousesETL_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "640",
      height: "579",
      src: (DeliveryWarehousesETL_2x_default()),
      alt: "Delivery Warehouses ETL",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var DeliveryWarehousesEtl_DeliveryWarehousesETLImage = (DeliveryWarehousesETLImage);
;// CONCATENATED MODULE: ./src/views/Infrastructure/components/DeliveryWarehousesEtl/DeliveryWarehousesETL.tsx


function DeliveryWarehousesETL_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var DeliveryWarehousesETL_data = {
  anchorId: "warehouses-etl",
  overline: "Delivery",
  heading: "Warehouses / ETL",
  description: "Most companies load data into a data warehouse. It\u2019s the source of truth for various analytics deep dives. Getting data in there can be challenging, as you need to consider schema inference, data cleaning, loading at off peak hours, and incrementally syncing new data. Here\u2019s how we do it.",
  link1: "https://news.ycombinator.com/item?id=14508413",
  link1Text: "Sorted by custom ID format (66 comments)",
  link2: "https://news.ycombinator.com/item?id=13886885",
  link2Text: "Proactively identifies and limits hot shards (252 comments)",
  accordionSection: SectionWithAccordion.WAREHOUSES_ETL
};

var DeliveryWarehousesETL_DeliveryWarehousesETL = function DeliveryWarehousesETL() {
  var anchorId = DeliveryWarehousesETL_data.anchorId,
      overline = DeliveryWarehousesETL_data.overline,
      heading = DeliveryWarehousesETL_data.heading,
      description = DeliveryWarehousesETL_data.description,
      link1 = DeliveryWarehousesETL_data.link1,
      link1Text = DeliveryWarehousesETL_data.link1Text,
      link2 = DeliveryWarehousesETL_data.link2,
      link2Text = DeliveryWarehousesETL_data.link2Text,
      accordionSection = DeliveryWarehousesETL_data.accordionSection;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeliveryWarehousesETL_Wrapper, {
    id: anchorId,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      copyVariant: "wide",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            children: heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* Description */.dk, {
            tag: "div",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeliveryWarehousesETL_CopyTextDescriptionSection, {
              children: description
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeliveryWarehousesETL_CopyTextDescriptionSection, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "pLarge",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                  href: link1,
                  children: link1Text
                })
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeliveryWarehousesETL_CopyTextDescriptionSection, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "pLarge",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                  href: link2,
                  children: link2Text
                })
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionSection_AccordionSection, {
              section: accordionSection
            })]
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeliveryWarehousesETL_StyledSectionContents, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeliveryWarehousesEtl_DeliveryWarehousesETLImage, {})
      })]
    })
  });
};

var DeliveryWarehousesETL_CopyTextDescriptionSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1m134042"
} : 0)( true ? {
  name: "1s22u92",
  styles: "margin-bottom:32px"
} : 0);

var DeliveryWarehousesETL_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1m134041"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);

var DeliveryWarehousesETL_StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e1m134040"
} : 0)( true ? {
  name: "y1f223",
  styles: "margin:auto"
} : 0);

/* harmony default export */ var DeliveryWarehousesEtl_DeliveryWarehousesETL = (DeliveryWarehousesETL_DeliveryWarehousesETL);
// EXTERNAL MODULE: ./src/views/Infrastructure/assets/OgInfrastructure.jpg
var OgInfrastructure = __webpack_require__(25776);
var OgInfrastructure_default = /*#__PURE__*/__webpack_require__.n(OgInfrastructure);
;// CONCATENATED MODULE: ./src/views/Infrastructure/Infrastructure.tsx






























var GettingStarted = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(442), __webpack_require__.e(5124)]).then(__webpack_require__.bind(__webpack_require__, 42576));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(42576)];
    }
  }
});

var InfrastructureView = function InfrastructureView() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "The Twilio Segment Infrastructure | Twilio Segment",
      pageDescription: "Under the hood of the system that processes 1M+ events per second.",
      pageOG: (OgInfrastructure_default()),
      themeColor: theme.palette.brand.darkAcai[800],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {
        after: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subnavigation_Subnavigation, {})
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Collection_Collection, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_CollectionLibraries_CollectionLibraries, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_CollectionCloudSources_CollectionCloudSources, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_CollectionSourceFunctions_CollectionSourceFunctions, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionApi_CollectionAPI, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Processing_Processing, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_ProcessingValidationTransformation_ProcessingValidationTransformation, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_ProcessingDeduplication_ProcessingDeduplication, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProcessingGdprSuppression_ProcessingGDPRSuppression, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Aggregation_Aggregation, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_AggregationIdentityResolution_AggregationIdentityResolution, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AggregationProfileApi_AggregationProfileAPI, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AggregationReverseEtl_AggregationReverseETL, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_AggregationAudienceCreation_AggregationAudienceCreation, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Delivery_Delivery, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_DeliveryCentrifuge_DeliveryCentrifuge, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_DeliveryDestinations_DeliveryDestinations, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeliveryWarehousesEtl_DeliveryWarehousesETL, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted, {})]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e168zlvj0"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var Infrastructure_Infrastructure = (InfrastructureView);
;// CONCATENATED MODULE: ./src/pages/infrastructure.tsx



var Infrastructure = function Infrastructure() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Infrastructure_Infrastructure, {});
};

/* harmony default export */ var infrastructure = (Infrastructure);

/***/ }),

/***/ 83914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uT": function() { return /* reexport */ Body_Body; },
  "vs": function() { return /* reexport */ ContentWrapper_ContentWrapper; },
  "h4": function() { return /* reexport */ Accordion_Header_Header; },
  "JO": function() { return /* reexport */ Icon_Icon; },
  "yD": function() { return /* reexport */ JsonLdFaq; },
  "DK": function() { return /* reexport */ Accordion_SubTitle_SubTitle; },
  "xv": function() { return /* reexport */ Accordion_Text_Text; },
  "Dx": function() { return /* reexport */ Accordion_Title_Title; },
  "$t": function() { return /* reexport */ TitleWrapper_TitleWrapper; },
  "ZP": function() { return /* reexport */ Accordion_Base_Base; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Icon/Icon.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var VerticalLine = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e73wn6u2"
} : 0)("background:", function (_ref) {
  var background = _ref.background;
  return background;
}, ";opacity:", function (_ref2) {
  var opacity = _ref2.opacity;
  return opacity;
}, ";width:2px;height:12px;transition:300ms background,300ms opacity;position:absolute;top:0;left:5px;" + ( true ? "" : 0));
var HorizontalLine = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e73wn6u1"
} : 0)("background:", function (_ref3) {
  var background = _ref3.background;
  return background;
}, ";width:12px;height:2px;transition:300ms background;position:absolute;top:5px;left:0;" + ( true ? "" : 0));
var IconStyle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e73wn6u0"
} : 0)( true ? {
  name: "xcbroa",
  styles: "width:12px;height:12px;position:relative"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Icon/Icon.tsx


var _excluded = ["tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var BaseIcon = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(IconStyle, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalLine, _objectSpread({}, tokens)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalLine, _objectSpread({}, tokens))]
  }));
});
var Icon = (0,useDesignTokens/* withDesignTokens */.Y)(BaseIcon, function (_ref2) {
  var _ref2$opened = _ref2.opened,
      opened = _ref2$opened === void 0 ? false : _ref2$opened;
  return {
    opacity: opened ? 0 : 1
  };
}, {
  dark: function dark(theme, _ref3) {
    var opened = _ref3.opened;
    return {
      background: opened ? theme.palette.brand.segmentGreen[500] : theme.palette.brand.darkAcai[300]
    };
  },
  light: function light(theme, _ref4) {
    var opened = _ref4.opened;
    return {
      background: opened ? theme.palette.brand.boysenberry[500] : theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme, _ref5) {
    var opened = _ref5.opened;
    return {
      background: opened ? theme.palette.twilio.blue[60] : theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Icon_Icon = (Icon);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Icon/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Base/Base.views.ts

var Base = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ejcpq100"
} : 0)("width:100%;border-bottom:1px solid ", function (_ref) {
  var borderColor = _ref.borderColor;
  return borderColor;
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Base/Base.tsx


var Base_excluded = ["children", "tokens"];

function Base_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Base_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Base_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Base_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var AccordionBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Base_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Base, Base_objectSpread(Base_objectSpread(Base_objectSpread({}, tokens), {}, {
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var Base_Base = (0,useDesignTokens/* withDesignTokens */.Y)(AccordionBase, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[300]
    };
  },
  light: function light(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[300]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      borderColor: theme.palette.twilio.gray[20]
    };
  }
});
/* harmony default export */ var Accordion_Base_Base = (Base_Base);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Base/index.ts

// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Text/Text.views.ts


function Text_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Text = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1abg28t0"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Text/Text.tsx


var Text_excluded = ["children", "variant", "tokens"];

function Text_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Text_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Text_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Text_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseText = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "pMedium" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Text_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, Text_objectSpread(Text_objectSpread({
    ref: ref,
    variant: variant,
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var Text_Text = (0,useDesignTokens/* withDesignTokens */.Y)(BaseText, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Accordion_Text_Text = (Text_Text);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Text/index.ts

// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 1 modules
var AnimatePresence = __webpack_require__(51585);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Body/Body.tsx


var Body_excluded = ["children"];

function Body_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Body_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Body_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Body_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var Body = function Body(_ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Body_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, Body_objectSpread(Body_objectSpread({}, rest), {}, {
    initial: false,
    children: children
  }));
};

/* harmony default export */ var Body_Body = (Body);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(48714);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/ContentWrapper/ContentWrapper.views.ts


function ContentWrapper_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xuwow0"
} : 0)( true ? {
  name: "1sk9ltb",
  styles: "padding-bottom:32px;overflow:hidden"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/ContentWrapper/ContentWrapper.tsx


var ContentWrapper_excluded = ["children"];

function ContentWrapper_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function ContentWrapper_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ContentWrapper_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ContentWrapper_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var ContentWrapper = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, ContentWrapper_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion_minimal.m.div, {
    initial: "collapsed",
    animate: "open",
    exit: "collapsed",
    variants: {
      open: {
        opacity: 1,
        height: "auto"
      },
      collapsed: {
        opacity: 0,
        height: 0
      }
    },
    transition: {
      duration: 0.3,
      ease: [0.04, 0.62, 0.23, 0.98]
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, ContentWrapper_objectSpread(ContentWrapper_objectSpread({
      ref: ref
    }, rest), {}, {
      children: children
    }))
  }, "content");
});
/* harmony default export */ var ContentWrapper_ContentWrapper = (ContentWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/ContentWrapper/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Title/Title.views.ts


function Title_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "enok57o0"
} : 0)( true ? {
  name: "139xlyq",
  styles: "text-align:left;margin:16px 0;transition:300ms color"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Title/Title.tsx


var Title_excluded = ["children", "variant", "tokens"];

function Title_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Title_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Title_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Title_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseTitle = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "h4" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Title_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, Title_objectSpread(Title_objectSpread({
    ref: ref,
    variant: variant,
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var Title_Title = (0,useDesignTokens/* withDesignTokens */.Y)(BaseTitle, function () {
  return {};
}, {
  light: function light(theme, _ref2) {
    var opened = _ref2.opened;
    return {
      color: opened ? theme.palette.brand.boysenberry[500] : theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme, _ref3) {
    var opened = _ref3.opened;
    return {
      color: opened ? theme.palette.brand.segmentGreen[500] : theme.palette.brand.darkAcai[300]
    };
  },
  twilioLight: function twilioLight(theme, _ref4) {
    var opened = _ref4.opened;
    return {
      color: opened ? theme.palette.twilio.blue[60] : theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Accordion_Title_Title = (Title_Title);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Title/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/SubTitle/SubTitle.views.ts


function SubTitle_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var SubTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "elm17wd0"
} : 0)( true ? {
  name: "jhsf3s",
  styles: "text-align:left;margin:16px 0"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/SubTitle/SubTitle.tsx


var SubTitle_excluded = ["children", "variant", "tokens"];

function SubTitle_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function SubTitle_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? SubTitle_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SubTitle_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseSubTitle = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "pSmall" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, SubTitle_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubTitle, SubTitle_objectSpread(SubTitle_objectSpread({
    ref: ref,
    variant: variant,
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var SubTitle_SubTitle = (0,useDesignTokens/* withDesignTokens */.Y)(BaseSubTitle, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Accordion_SubTitle_SubTitle = (SubTitle_SubTitle);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/SubTitle/index.ts

// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/JsonLdFaq/JsonLdFaq.tsx


var JsonLdFaq = function JsonLdFaq(_ref) {
  var data = _ref.data;
  var entities = data.map(function (_ref2) {
    var question = _ref2.question,
        answer = _ref2.answer;
    return {
      '@type': "Question",
      name: question,
      acceptedAnswer: {
        '@type': "Answer",
        text: answer
      }
    };
  });
  var json = {
    '@context': "https://schema.org",
    '@type': "FAQPage",
    mainEntity: entities
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((head_default()), {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(json)
      }
    })
  });
};
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/JsonLdFaq/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/TitleWrapper/TitleWrapper.tsx


var TitleWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e16ehyoi0"
} : 0)( true ? "" : 0);

/* harmony default export */ var TitleWrapper_TitleWrapper = (TitleWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/TitleWrapper/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Header/Header.views.ts



var Header = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "eqrws8a0"
} : 0)("width:100%;display:grid;gap:28px;grid-template-columns:auto auto;align-items:center;justify-content:space-between;cursor:pointer;margin:12px 0;:hover{", Title, "{color:", function (_ref) {
  var hoverTitleColor = _ref.hoverTitleColor;
  return hoverTitleColor;
}, ";}", HorizontalLine, ",", VerticalLine, "{background-color:", function (_ref2) {
  var hoverIconBackgroundColor = _ref2.hoverIconBackgroundColor;
  return hoverIconBackgroundColor;
}, ";}}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Header/Header.tsx


var Header_excluded = ["children", "onClick", "tokens"];

function Header_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Header_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Header_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Header_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var HeaderBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Header_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, Header_objectSpread(Header_objectSpread(Header_objectSpread({
    onClick: onClick
  }, tokens), {}, {
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var Header_Header = (0,useDesignTokens/* withDesignTokens */.Y)(HeaderBase, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      hoverTitleColor: theme.palette.brand.segmentGreen[500],
      hoverIconBackgroundColor: theme.palette.brand.segmentGreen[500]
    };
  },
  light: function light(theme) {
    return {
      hoverTitleColor: theme.palette.brand.boysenberry[500],
      hoverIconBackgroundColor: theme.palette.brand.boysenberry[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      hoverTitleColor: theme.palette.twilio.blue[60],
      hoverIconBackgroundColor: theme.palette.twilio.blue[60]
    };
  }
});
/* harmony default export */ var Accordion_Header_Header = (Header_Header);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Header/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/index.ts










Accordion_Base_Base.displayName = "AccordionBase";
Accordion_Header_Header.displayName = "Accordion.Header";
Body_Body.displayName = "Accordion.Body";
Accordion_Text_Text.displayName = "Accordion.Text";
Accordion_Title_Title.displayName = "Accordion.Title";
Accordion_SubTitle_SubTitle.displayName = "Accordion.SubTitle";
TitleWrapper_TitleWrapper.displayName = "Accordion.TitleWrapper";
ContentWrapper_ContentWrapper.displayName = "Accordion.ContentWrapper";
Icon_Icon.displayName = "Accordion.Icon";
JsonLdFaq.displayName = "Accordion.JsonLdFaq";


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 74864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ useActiveState; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useActiveState/useActiveState.tsx



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var DEFAULT_OPTIONS = {
  allowMultipleActive: false,
  minActive: 0
};
/**
 * A hook that provides a stateful array of booleans and functions to toggle, enable and disable them.
 * @param initialState The initial state of the array of booleans.
 * @param options Options to configure the hook.
 * @returns The stateful array of booleans and functions to toggle, enable and disable them.
 */

var useActiveState = function useActiveState(initialState, options) {
  var _useState = (0,react.useState)(initialState),
      activeItems = _useState[0],
      setActiveItems = _useState[1];

  var settings = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);

  var toggle = function toggle(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    if (items[index]) {
      var activeItemsLength = items.filter(function (item) {
        return item;
      }).length;

      if (activeItemsLength > settings.minActive) {
        items[index] = false;
      }
    } else {
      if (!settings.allowMultipleActive) {
        items = new Array(items.length).fill(false);
      }

      items[index] = true;
    }

    setActiveItems(items);
  };

  var enable = function enable(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    if (!settings.allowMultipleActive) {
      items = new Array(items.length).fill(false);
    }

    items[index] = true;
    setActiveItems(items);
  };

  var disable = function disable(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    var activeItemsLength = items.filter(function (item) {
      return item;
    }).length;

    if (activeItemsLength > settings.minActive) {
      items[index] = false;
      setActiveItems(items);
    }
  };

  return {
    activeItems: activeItems,
    setActiveItems: setActiveItems,
    toggle: toggle,
    enable: enable,
    disable: disable
  };
};
;// CONCATENATED MODULE: ../../libs/utils/useActiveState/index.ts


/***/ }),

/***/ 68714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _useScrollToAnchor__WEBPACK_IMPORTED_MODULE_0__.Z; },
/* harmony export */   "d": function() { return /* reexport safe */ _useScrollToAnchor__WEBPACK_IMPORTED_MODULE_0__.d; }
/* harmony export */ });
/* harmony import */ var _useScrollToAnchor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83390);


/***/ }),

/***/ 83390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ scrollToAnchor; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var scrollToAnchor = function scrollToAnchor(anchorId) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var addAnchorToUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var anchor = document.getElementById(anchorId);

  if (anchor) {
    var y = anchor.getBoundingClientRect().top + window.pageYOffset + offset;
    window.scrollTo({
      top: y,
      behavior: "smooth"
    });

    if (addAnchorToUrl) {
      history.pushState({}, "", "#".concat(anchorId));
    }
  }
};
/**
 * Scroll into view, given an anchor (element.id)
 *
 * @param anchorId - element id to be queried and scrolled to.
 * @param offset - offset from the top of the element to scroll to.
 * @return a function that scrolls to the anchor.
 */

var useScrollToAnchor = function useScrollToAnchor(anchorId) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var scroll = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    scrollToAnchor(anchorId, offset);
  }, [anchorId, offset]);
  return scroll;
};

/* harmony default export */ __webpack_exports__["Z"] = (useScrollToAnchor);

/***/ }),

/***/ 82966:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/infrastructure",
      function () {
        return __webpack_require__(92763);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 25776:
/***/ (function(module) {

module.exports = "/_next/static/images/OgInfrastructure-cc8c753da9631553b3096db0d948dd52.jpg";

/***/ }),

/***/ 74178:
/***/ (function(module) {

module.exports = "/_next/static/images/Aggregation@2x-e855911a74facc772e4035d624f7ac33.png";

/***/ }),

/***/ 4958:
/***/ (function(module) {

module.exports = "/_next/static/images/AggregationAudienceCreation@2x-5351745d8ec03f4ca1ada27cf5209d54.png";

/***/ }),

/***/ 74013:
/***/ (function(module) {

module.exports = "/_next/static/images/AggregationIdentityResolution@2x-60aae68dfcce7d456d09312d6e90164f.png";

/***/ }),

/***/ 54174:
/***/ (function(module) {

module.exports = "/_next/static/images/AggregationProfileAPI@2x-12d4d0d786593307c0f55fe93f869b97.png";

/***/ }),

/***/ 41287:
/***/ (function(module) {

module.exports = "/_next/static/images/AggregationReverseETL@2x-370e290e992d07fc1aeb6cd0616cc9f7.png";

/***/ }),

/***/ 91460:
/***/ (function(module) {

module.exports = "/_next/static/images/Collection@2x-8f346fafa456f5d72bcfa1fb94154e73.png";

/***/ }),

/***/ 98009:
/***/ (function(module) {

module.exports = "/_next/static/images/CollectionAPI@2x-7ea5ae124324f6a8811dddc18dd5eb4b.png";

/***/ }),

/***/ 90414:
/***/ (function(module) {

module.exports = "/_next/static/images/CollectionCloudSources@2x-6f2c8c36f2a999412d41ed3b483f5192.png";

/***/ }),

/***/ 29251:
/***/ (function(module) {

module.exports = "/_next/static/images/CollectionLibraries@2x-e1f95ed5624f714f0c363e2c4ec6049c.png";

/***/ }),

/***/ 50007:
/***/ (function(module) {

module.exports = "/_next/static/images/CollectionSourceFunctions@2x-17eac567c19c0025445d3d0e67a8ec38.png";

/***/ }),

/***/ 57076:
/***/ (function(module) {

module.exports = "/_next/static/images/Delivery@2x-68959d058be572ba534fa5b6e50bba33.png";

/***/ }),

/***/ 34590:
/***/ (function(module) {

module.exports = "/_next/static/images/DeliveryCentrifuge@2x-ae980a532ca6d27a9c2cbca2dda7809f.png";

/***/ }),

/***/ 98370:
/***/ (function(module) {

module.exports = "/_next/static/images/DeliveryDestinations@2x-e3425e3f64c4493b305ff1e699516b0a.png";

/***/ }),

/***/ 52273:
/***/ (function(module) {

module.exports = "/_next/static/images/DeliveryWarehousesETL@2x-a9df711ef64be461be8e60c378e58df7.png";

/***/ }),

/***/ 32924:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-6fd2da90b8a06e5d093638c7ef6e9dfe.png";

/***/ }),

/***/ 37795:
/***/ (function(module) {

module.exports = "/_next/static/images/Processing@2x-09b1ae378a1b04e0e9e6b3ae300f0d88.png";

/***/ }),

/***/ 47402:
/***/ (function(module) {

module.exports = "/_next/static/images/ProcessingDeduplication@2x-1255dcbda3f2429832ef6b312eb78144.png";

/***/ }),

/***/ 8100:
/***/ (function(module) {

module.exports = "/_next/static/images/ProcessingGDPRSuppression@2x-6680057f88c201ef51b88f070cbf64ea.png";

/***/ }),

/***/ 18191:
/***/ (function(module) {

module.exports = "/_next/static/images/ProcessingValidationTransformation@2x-4f112ab6f06dc51641bfb6f39b261e3e.png";

/***/ }),

/***/ 56147:
/***/ (function(module) {

module.exports = "/_next/static/images/Aggregation-5341b10b62bfd28e333ae3e10527056c.webp";

/***/ }),

/***/ 40572:
/***/ (function(module) {

module.exports = "/_next/static/images/Aggregation@2x-769f7301ce245d43b92d0428256434ad.webp";

/***/ }),

/***/ 90071:
/***/ (function(module) {

module.exports = "/_next/static/images/AggregationAudienceCreation-1bb5e76977d268ad807dc6d26f1c16ed.webp";

/***/ }),

/***/ 74651:
/***/ (function(module) {

module.exports = "/_next/static/images/AggregationAudienceCreation@2x-d2faca2c226f4aa6d4207870ea22a46a.webp";

/***/ }),

/***/ 81952:
/***/ (function(module) {

module.exports = "/_next/static/images/AggregationIdentityResolution-b57d831abd1687fe7f1158a5995ce653.webp";

/***/ }),

/***/ 26186:
/***/ (function(module) {

module.exports = "/_next/static/images/AggregationIdentityResolution@2x-b819d9315c1271b3f7bbbaf3ff1ad031.webp";

/***/ }),

/***/ 38247:
/***/ (function(module) {

module.exports = "/_next/static/images/AggregationProfileAPI-a443f02984dfe21e30aa9947b43d4943.webp";

/***/ }),

/***/ 82300:
/***/ (function(module) {

module.exports = "/_next/static/images/AggregationProfileAPI@2x-78ff64e24a18c79178d1be914bcbe08f.webp";

/***/ }),

/***/ 8263:
/***/ (function(module) {

module.exports = "/_next/static/images/AggregationReverseETL-2a2fa7717a6b3037e2053fc88ca7d22f.webp";

/***/ }),

/***/ 29131:
/***/ (function(module) {

module.exports = "/_next/static/images/AggregationReverseETL@2x-541cda4113a2230bfae1cd7d63702c63.webp";

/***/ }),

/***/ 89456:
/***/ (function(module) {

module.exports = "/_next/static/images/Collection-4da2983aac0c509d59f26aa95388dee8.webp";

/***/ }),

/***/ 85428:
/***/ (function(module) {

module.exports = "/_next/static/images/Collection@2x-0d7d8cc027b16ffc5aea986775a6c75a.webp";

/***/ }),

/***/ 28268:
/***/ (function(module) {

module.exports = "/_next/static/images/CollectionAPI-0c7b8b388b47955149ee89558c29a100.webp";

/***/ }),

/***/ 32387:
/***/ (function(module) {

module.exports = "/_next/static/images/CollectionAPI@2x-d8333e31376f8cc3ce1a72be169d3a3d.webp";

/***/ }),

/***/ 24752:
/***/ (function(module) {

module.exports = "/_next/static/images/CollectionCloudSources-f46af73f9659f1bcc30cfa752d4671a7.webp";

/***/ }),

/***/ 5784:
/***/ (function(module) {

module.exports = "/_next/static/images/CollectionCloudSources@2x-30703eb26e23d502ae6a028e3ff1133c.webp";

/***/ }),

/***/ 23656:
/***/ (function(module) {

module.exports = "/_next/static/images/CollectionLibraries-6a46416a1aa9ecce29e3c307fa81a86d.webp";

/***/ }),

/***/ 69624:
/***/ (function(module) {

module.exports = "/_next/static/images/CollectionLibraries@2x-e7ac8d52c784645f2f1aabbd58cc3a26.webp";

/***/ }),

/***/ 62464:
/***/ (function(module) {

module.exports = "/_next/static/images/CollectionSourceFunctions-971ac62d562b050422c90b01aed196ea.webp";

/***/ }),

/***/ 2104:
/***/ (function(module) {

module.exports = "/_next/static/images/CollectionSourceFunctions@2x-e00ccc9652e7da0dbf31a619d46797ca.webp";

/***/ }),

/***/ 98443:
/***/ (function(module) {

module.exports = "/_next/static/images/Delivery-791c832a756e9b141b64b2f0da5e05a7.webp";

/***/ }),

/***/ 10457:
/***/ (function(module) {

module.exports = "/_next/static/images/Delivery@2x-3a00e8e43fa6c05675e847d4c737de41.webp";

/***/ }),

/***/ 27612:
/***/ (function(module) {

module.exports = "/_next/static/images/DeliveryCentrifuge-5667df5e914c30a370114a921170e349.webp";

/***/ }),

/***/ 84605:
/***/ (function(module) {

module.exports = "/_next/static/images/DeliveryCentrifuge@2x-0ea60721d6ca6675d569a284e2305625.webp";

/***/ }),

/***/ 21976:
/***/ (function(module) {

module.exports = "/_next/static/images/DeliveryDestinations-1058150b071e29ce7ec27990ed949add.webp";

/***/ }),

/***/ 61166:
/***/ (function(module) {

module.exports = "/_next/static/images/DeliveryDestinations@2x-b5575e7c8b7632cf3fabae17080b8ce1.webp";

/***/ }),

/***/ 20584:
/***/ (function(module) {

module.exports = "/_next/static/images/DeliveryWarehousesETL-ace3435c3955fd6123497c2f4a17ad6f.webp";

/***/ }),

/***/ 52247:
/***/ (function(module) {

module.exports = "/_next/static/images/DeliveryWarehousesETL@2x-ab688a597327e2ee1a2f557661848591.webp";

/***/ }),

/***/ 77517:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-05a0d2f5b97290e434fa1c2b535056b9.webp";

/***/ }),

/***/ 36863:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-69c9e9b844a86a6d2cd1d7f4cc11b9e2.webp";

/***/ }),

/***/ 94714:
/***/ (function(module) {

module.exports = "/_next/static/images/Processing-eefeea2a2a7f22cf689752e32f645b80.webp";

/***/ }),

/***/ 75193:
/***/ (function(module) {

module.exports = "/_next/static/images/Processing@2x-e6b6a7217472d7a083a912e129683744.webp";

/***/ }),

/***/ 68444:
/***/ (function(module) {

module.exports = "/_next/static/images/ProcessingDeduplication-4efe306529379765c06f073c4e65bee7.webp";

/***/ }),

/***/ 95672:
/***/ (function(module) {

module.exports = "/_next/static/images/ProcessingDeduplication@2x-78737f68f43a886ae2d6c7465d2e9f2a.webp";

/***/ }),

/***/ 56192:
/***/ (function(module) {

module.exports = "/_next/static/images/ProcessingGDPRSuppression-3dea08fdd0a6f2d70c00cfa7637f5808.webp";

/***/ }),

/***/ 35035:
/***/ (function(module) {

module.exports = "/_next/static/images/ProcessingGDPRSuppression@2x-5a342d9e86e6721f05e59c41f14159a7.webp";

/***/ }),

/***/ 18023:
/***/ (function(module) {

module.exports = "/_next/static/images/ProcessingValidationTransformation-40256528b5f8ce9436074acbbc8c94f5.webp";

/***/ }),

/***/ 87939:
/***/ (function(module) {

module.exports = "/_next/static/images/ProcessingValidationTransformation@2x-c132585962b61c0ab1a40d029022c080.webp";

/***/ }),

/***/ 76527:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 96969:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 32232:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 24195:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,8834,4330,6413,1382,4136,8392,2073,7096,2429,7303,8187,9833,9774,2888,179], function() { return __webpack_exec__(82966); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);